export function VIFRedoAddSub(cjs, an) {
  var p; // shortcut to reference prototypes
  var lib = {};
  var ss = {};
  var img = {};
  lib.ssMetadata = [];

  (lib.AnMovieClip = function () {
    this.actionFrames = [];
    this.ignorePause = false;
    this.gotoAndPlay = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
    };
    this.play = function () {
      cjs.MovieClip.prototype.play.call(this);
    };
    this.gotoAndStop = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
    };
    this.stop = function () {
      cjs.MovieClip.prototype.stop.call(this);
    };
  }).prototype = p = new cjs.MovieClip();
  // symbols:
  // helper functions:

  function mc_symbol_clone() {
    var clone = this._cloneProps(
      new this.constructor(
        this.mode,
        this.startPosition,
        this.loop,
        this.reversed,
      ),
    );
    clone.gotoAndStop(this.currentFrame);
    clone.paused = this.paused;
    clone.framerate = this.framerate;
    return clone;
  }

  function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
    var prototype = cjs.extend(symbol, cjs.MovieClip);
    prototype.clone = mc_symbol_clone;
    prototype.nominalBounds = nominalBounds;
    prototype.frameBounds = frameBounds;
    return prototype;
  }

  (lib.ValueTextBlack_line = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(2));

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#000000').ss(2, 0, 1).p('AifAAIE/AA');

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f().s('#FFFFFF').ss(2, 0, 1).p('AihAAIFDAA');
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.1, -1, 34.3, 2);

  (lib.ValueText_glow = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .rf(
        [
          'rgba(255,255,255,0.502)',
          'rgba(255,255,255,0.8)',
          'rgba(255,255,255,0)',
        ],
        [0, 0, 1],
        0,
        0,
        0,
        0,
        0,
        20.8,
      )
      .s()
      .p(
        'AiRCSQg9g8ABhWQgBhVA9g8QA8g9BVAAQBVAAA9A9QA9A8gBBVQABBWg9A8Qg9A9hVAAQhVAAg8g9g',
      );
    this.shape.setTransform(0.0184, -0.0236, 1.4528, 1.4492);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.ValueText_glow,
    new cjs.Rectangle(-30, -30, 60, 60),
    null,
  );

  (lib.comsuntexsymbolsValueText = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.smallText = new cjs.Text('1', "bold 16px 'Open Sans Condensed'");
    this.smallText.name = 'smallText';
    this.smallText.lineHeight = 23;
    this.smallText.lineWidth = 57;
    this.smallText.parent = this;
    this.smallText.setTransform(-11, 2);

    this.timeline.addTween(cjs.Tween.get(this.smallText).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsValueText,
    new cjs.Rectangle(-13, 0, 61.3, 27.1),
    null,
  );

  (lib.number = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };
    this.frame_5 = function () {
      this.stop();
    };
    this.frame_6 = function () {
      this.stop();
    };
    this.frame_7 = function () {
      this.stop();
    };
    this.frame_8 = function () {
      this.stop();
    };
    this.frame_9 = function () {
      this.stop();
    };
    this.frame_10 = function () {
      this.stop();
    };
    this.frame_11 = function () {
      this.stop();
    };
    this.frame_12 = function () {
      this.stop();
    };
    this.frame_13 = function () {
      this.stop();
    };
    this.frame_14 = function () {
      this.stop();
    };
    this.frame_15 = function () {
      this.stop();
    };
    this.frame_16 = function () {
      this.stop();
    };
    this.frame_17 = function () {
      this.stop();
    };
    this.frame_18 = function () {
      this.stop();
    };
    this.frame_19 = function () {
      this.stop();
    };
    this.frame_20 = function () {
      this.stop();
    };
    this.frame_21 = function () {
      this.stop();
    };
    this.frame_22 = function () {
      this.stop();
    };
    this.frame_23 = function () {
      this.stop();
    };
    this.frame_24 = function () {
      this.stop();
    };
    this.frame_25 = function () {
      this.stop();
    };
    this.frame_26 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1)
        .call(this.frame_5)
        .wait(1)
        .call(this.frame_6)
        .wait(1)
        .call(this.frame_7)
        .wait(1)
        .call(this.frame_8)
        .wait(1)
        .call(this.frame_9)
        .wait(1)
        .call(this.frame_10)
        .wait(1)
        .call(this.frame_11)
        .wait(1)
        .call(this.frame_12)
        .wait(1)
        .call(this.frame_13)
        .wait(1)
        .call(this.frame_14)
        .wait(1)
        .call(this.frame_15)
        .wait(1)
        .call(this.frame_16)
        .wait(1)
        .call(this.frame_17)
        .wait(1)
        .call(this.frame_18)
        .wait(1)
        .call(this.frame_19)
        .wait(1)
        .call(this.frame_20)
        .wait(1)
        .call(this.frame_21)
        .wait(1)
        .call(this.frame_22)
        .wait(1)
        .call(this.frame_23)
        .wait(1)
        .call(this.frame_24)
        .wait(1)
        .call(this.frame_25)
        .wait(1)
        .call(this.frame_26)
        .wait(1),
    );

    // number
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p('AAcHJIAAoVQAAhWAEhPIgVAbIgbAhIhPBSIhnhlID0kAICZAAIAAORg');
    this.shape.setTransform(18.25, 75.075);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'Aj3HPIAAh8ICwj0QA4hOAcgyQAeg1AKgnQAKgoAAgpQAAgwgWgdQgXgcgsAAQgkAAggASQggAUgnAwIhUhyQA5hEA4gbQA5gcBJgBQBHABA3AfQA3AeAfA3QAfA3AABLQAAA8gPA3QgOA3gjA5QgiA8g8BLIh5CgIAAAGIEkAAIAACXg',
      );
    this.shape_1.setTransform(20.825, 79.4);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p(
        'AiTHNQgwgJg3gZIAAiiQBgA5BaAAQBFAAAhgiQAhgiAAg+QAAhEgpggQgogghZAAIguAAIAAiPIAvAAQBQAAAogkQAqgjAAg/QAAhnhlAAQgmAAgjAQQgjAPglAeIhEh9QA5guA6gTQA5gUBKAAQBtAABAA8QBAA8AABwQAABKgnA5QgoA5hMAbIAAAEQCtAkAAC2QAAB8hNBJQhNBJiHAAQg8AAgxgJg',
      );
    this.shape_2.setTransform(21.675, 75.025);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p(
        'AAVHKIAAi5IkuAAIAAiLIEspPICqAAIAAJMIBcAAIAACOIhcAAIAAC5gAAAimQgKAYgLAXIh4D6ICgAAIAAjTIABgrIABg6IACglIgFAAQgJAbgJAZg',
      );
    this.shape_3.setTransform(22.7, 74.95);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'AjwGkIAAigQApAYAvAQQAuAPArAAQBAAAAggsQAhgrAAhIQAAiQiDAAQgyAAg5AVIg5gqIAbnFIGMAAIAACXIj8AAIgMC9QAbgHAXgCQAVgCASAAQBDAAAyAkQAxAkAcA/QAcBAAABUQAACUhJBTQhJBSiTAAQhxAAhLgrg',
      );
    this.shape_4.setTransform(22.675, 75.7);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'Ai4FtQhGhqAAi+QAAhvARhiQAQhhAohKQAnhKBDgqQBDgqBkAAQBAAAA2AMIAACTQgYgFgagEQgagDgcAAQhgAAgwBGQgxBGgFCUIAFAAQArhpBjAAQBgAAA0BRQA0BQAACEQAABegdBHQgdBHg3AoQg3AohPAAQh8AAhEhpgAg5AsQgXAmAAA0QAAAuAJArQAJArATAcQATAaAbAAQAlAAAWgoQAVgoAAhSQAAiXhOAAQgnAAgXAlg',
      );
    this.shape_5.setTransform(22.575, 75.025);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p('Ai7HJIELr5IlOAAIAAiYIH9AAIAAB3IkEMag');
    this.shape_6.setTransform(22.275, 75.075);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#000000')
      .s()
      .p(
        'Ai/GVQhEhCAAh0QAAhMAig8QAjg8BJguQg9gxgdg5Qgdg5AAhEQAAhmBAg6QBAg7BtAAQByAAA+A7QA9A6AABmQAABKgfA5QggA4hFApQBPA2AlA5QAmA4AABKQAAB0hGBEQhFBDh4AAQh8AAhEhBgAhJCHQgVAlABAwQAAAyAXAfQAYAfAtAAQAxAAAYgeQAYgeAAg0QAAgkgSgjQgRgigwgmIgRgOQgxAkgUAkgAg0kxQgUAZAAArQAAAoASAgQATAfAjAcQArggARgeQARgfAAgmQAAgrgVgZQgVgZgiAAQggAAgVAZg',
      );
    this.shape_7.setTransform(22.3, 75.025);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p(
        'AiZHTQgfgEgbgGIAAiTQAvAOA5AAQBnAAAuhNQAwhOAFiFIgHAAQgtBphhAAQhiAAgzhRQgzhQAAiEQAAhfAdhGQAdhIA3goQA4goBRAAQB6AABFBpQBEBoAAC7QAAB0gSBjQgTBjgpBKQgoBJhDApQhDAphfAAQgeAAgfgDgAg9kXQgXAoAABTQAACXBQAAQAdAAATgUQATgVAJgeQAIgfAAgcQAAgWgDgfQgDgfgJgeQgIgegRgUQgRgUgaAAQgkAAgWAog',
      );
    this.shape_8.setTransform(22.075, 75.025);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p(
        'Ai7FoQhAhuAAj6QAAjwA+hyQA+hzB/AAQD8AAAAHVQAACLgWBqQgXBpg3A8Qg3A8hhAAQh7AAhAhugAg9jtQgSBPAACeQAACkARBNQARBNAtAAQAuAAARhNQAQhNAAikQAAidgQhQQgRhPguAAQgsAAgRBPg',
      );
    this.shape_9.setTransform(49.475, 75.025);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p('AAcHJIAAoVQAAhWADhPIgUAbIgbAhIhQBSIhmhlID1kAICYAAIAAORg');
    this.shape_10.setTransform(-14.65, 75.075);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#000000')
      .s()
      .p(
        'Aj3HQIAAh9ICwj0QA4hPAcgyQAeg0AKgnQAKgoAAgpQAAgwgWgcQgXgdgsAAQgkAAggATQggASgnAwIhUhxQA5hEA4gbQA5gcBJAAQBHgBA3AgQA3AfAfA3QAfA3AABJQAAA9gPA3QgOA2gjA6QgiA8g8BLIh5CgIAAAHIEkAAIAACXg',
      );
    this.shape_11.setTransform(-12.075, 74.4);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p(
        'AAUHKIAAi5IksAAIAAiLIErpPICqAAIAAJMIBcAAIAACOIhcAAIAAC5gAAAimQgKAYgKAXIh5D6ICgAAIAAjTIAAgrIADg6IABglIgFAAQgIAbgKAZg',
      );
    this.shape_12.setTransform(-10.2, 74.95);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#000000')
      .s()
      .p(
        'Ai/GVQhEhCAAh0QAAhMAjg8QAhg8BLguQg+gxgcg5Qgeg5AAhEQAAhmBBg6QA/g7BtAAQByAAA+A7QA9A6AABmQAABKgfA5QggA4hFApQBPA2AlA5QAmA4AABKQAAB0hFBEQhGBDh4AAQh8AAhEhBgAhJCHQgVAlAAAwQAAAyAZAfQAXAfAuAAQAwAAAZgeQAXgeAAg0QAAgkgSgjQgRgigwgmIgRgOQgxAkgUAkgAgzkxQgVAZAAArQAAAoATAgQASAfAjAcQArggARgeQARgfAAgmQAAgrgVgZQgVgZgiAAQggAAgUAZg',
      );
    this.shape_13.setTransform(-10.6, 75.025);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p('AAcHJIAAoVQAAhWAEhPIgVAbIgbAhIhQBSIhmhlID0kAICZAAIAAORg');
    this.shape_14.setTransform(42.9, 75.075);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p('AAcHJIAAoVQAAhWADhPIgUAbIgbAhIhQBSIhmhlID0kAICZAAIAAORg');
    this.shape_15.setTransform(-17.15, 75.075);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#000000')
      .s()
      .p(
        'AAVHKIAAi5IkuAAIAAiLIEspPICqAAIAAJMIBdAAIAACOIhdAAIAAC5gAAAimQgJAYgLAXIh5D6ICgAAIAAjTIABgrIACg6IABglIgFAAQgJAbgJAZg',
      );
    this.shape_16.setTransform(49.85, 74.95);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#000000')
      .s()
      .p(
        'Ai/GVQhEhCAAh0QAAhMAjg8QAhg8BLguQg+gxgcg5Qgeg5AAhEQAAhmBBg6QA/g7BtAAQByAAA+A7QA9A6AABmQAABKgfA5QggA4hFApQBPA2AmA5QAlA4AABKQAAB0hGBEQhFBDh4AAQh9AAhDhBgAhJCHQgUAlgBAwQAAAyAYAfQAYAfAuAAQAwAAAZgeQAXgeAAg0QAAgkgRgjQgSgigwgmIgRgOQgxAkgUAkgAg0kxQgUAZAAArQAAAoATAgQASAfAjAcQArggARgeQARgfAAgmQAAgrgVgZQgVgZgiAAQggAAgVAZg',
      );
    this.shape_17.setTransform(49.45, 75.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_2, p: { x: 21.675 } }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_4, p: { x: 22.675 } }] }, 1)
        .to({ state: [{ t: this.shape_5, p: { x: 22.575 } }] }, 1)
        .to({ state: [{ t: this.shape_6, p: { x: 22.275 } }] }, 1)
        .to({ state: [{ t: this.shape_7 }] }, 1)
        .to({ state: [{ t: this.shape_8, p: { x: 22.075 } }] }, 1)
        .to({ state: [{ t: this.shape_10 }, { t: this.shape_9 }] }, 1)
        .to(
          {
            state: [
              { t: this.shape_11, p: { x: -12.075 } },
              { t: this.shape_9 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_2, p: { x: -11.225 } },
              { t: this.shape_9 },
            ],
          },
          1,
        )
        .to({ state: [{ t: this.shape_12 }, { t: this.shape_9 }] }, 1)
        .to(
          {
            state: [
              { t: this.shape_4, p: { x: -10.225 } },
              { t: this.shape_9 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_5, p: { x: -10.325 } },
              { t: this.shape_9 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_6, p: { x: -10.625 } },
              { t: this.shape_9 },
            ],
          },
          1,
        )
        .to({ state: [{ t: this.shape_13 }, { t: this.shape_9 }] }, 1)
        .to(
          {
            state: [
              { t: this.shape_8, p: { x: -10.825 } },
              { t: this.shape_9 },
            ],
          },
          1,
        )
        .to({ state: [{ t: this.shape_10 }, { t: this.shape_9 }] }, 1)
        .to({ state: [{ t: this.shape_15 }, { t: this.shape_14 }] }, 1)
        .to(
          {
            state: [
              { t: this.shape_10 },
              { t: this.shape_11, p: { x: 47.975 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_10 },
              { t: this.shape_2, p: { x: 48.825 } },
            ],
          },
          1,
        )
        .to({ state: [{ t: this.shape_10 }, { t: this.shape_16 }] }, 1)
        .to(
          {
            state: [
              { t: this.shape_10 },
              { t: this.shape_4, p: { x: 49.825 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_10 },
              { t: this.shape_5, p: { x: 49.725 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_10 },
              { t: this.shape_6, p: { x: 49.425 } },
            ],
          },
          1,
        )
        .to({ state: [{ t: this.shape_10 }, { t: this.shape_17 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-58, -25.1, 155.1, 193.6);

  (lib.hitArea = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#FFFFFF').s().p('AksE7IAAp1IJZAAIAAJ1g');
    this.shape.setTransform(0.425, -0.15);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.hitArea,
    new cjs.Rectangle(-29.7, -31.6, 60.3, 63),
    null,
  );

  (lib.Scoreboard_progressMeter_fill = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#FFFF00').s().p('AvnCWIAAkrIfPAAIAAErg');
    this.shape.setTransform(100, 0);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Scoreboard_progressMeter_fill,
    new cjs.Rectangle(0, -15, 200, 30),
    null,
  );

  (lib.Scoreboard_changeRoundBtn = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgRAhIgKgEIAAgRIABAAIAEACIAFADIAGADIAIABQAEAAADgCQADgBAAgDQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBIgGgCIgFgBIgGgCQgIgCgEgEQgEgEAAgIQAAgFACgDQACgEAEgDQAEgDAGgCQAFgCAHAAQAHAAAFACQAGABAEACIAAAQIgBAAIgEgCIgEgCIgGgCIgHgBQgDAAgDACQgBAAgBABQAAAAAAABQgBAAAAABQAAAAAAABQAAAAAAABQAAAAAAABQAAAAABAAQAAABAAAAQACACAEABIAGABIAHACQAHACADADQAEAFAAAHQAAAFgCAEQgCAEgEADQgEADgGACQgGACgHAAQgHAAgHgCg',
      );
    this.shape.setTransform(19.525, 9.825);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgZAlQgGgJAAgQQAAgJACgFQACgGAEgFQAEgEAFgDQAFgCAGAAIAHABIAIAEIAAgdIAUAAIAABbIgUAAIAAgHIgFADIgEADIgEACIgGABQgLAAgHgKgAgGgCQgEAFAAAJQAAAKADAEQADAEAFAAQADAAADgBIAFgCIAAggIgEgBIgEAAQgHAAgDAEg',
      );
    this.shape_1.setTransform(12.325, 8.65);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAKAiIAAghIAAgHIgBgGIgDgDIgGgBIgEABIgFADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAEgCQAEgDAGAAQAKAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_2.setTransform(4.975, 9.725);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYAcQgGgHAAgMIAAgqIAVAAIAAAhIAAAHIABAGIADACQACACADAAIAFgCIAFgCIAAguIAVAAIAABBIgVAAIAAgIIgKAIQgDACgGAAQgKAAgFgGg',
      );
    this.shape_3.setTransform(-2.775, 9.9);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYAZQgJgIAAgRQAAgQAJgIQAJgKAPAAQAQAAAJAKQAJAJAAAPQAAARgJAIQgIAKgRAAQgPAAgJgKgAgEgTIgEAEQgCACgBAEIgBAJIABAKIACAGIAFAEIAEABIAFgBIAEgEIADgGIABgKIgBgJIgDgFQgCgDgCgBIgFgBIgEAAg',
      );
    this.shape_4.setTransform(-10.3, 9.8);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAOAsIgYghIgHAAIAAAhIgWAAIAAhWIAjAAIAMAAQAFABAEADQAFADADAEQADAFAAAHQAAAKgFAGQgEAGgIADIAdAmgAgRgDIAGAAIAIgBIAEgCIADgEIABgGQAAgEgBgCQgBgCgDgBIgEgBIgGAAIgHAAg',
      );
    this.shape_5.setTransform(-17.775, 8.75);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgWAaQgKgJAAgRQAAgOAKgKQAJgKAPAAQAQAAAHAIQAIAJAAAPIAAAGIgsAAIACAIQABADADABQADACACABIAIABIAHgBIAGgCIAFgCIADgCIADAAIAAARIgFABIgGACIgHABIgIABQgSAAgKgJgAgHgRQgEAEAAAFIAYAAQgBgGgCgEQgDgCgGAAQgFAAgDADg',
      );
    this.shape_6.setTransform(19.025, -4.7);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgOAtIgKgCIAAgQIACAAIAEABIAEABIAFABIAFABIAIgBIAFgDQACgCAAgDIABgHIAAgBQgEADgEABQgEACgEAAQgNAAgHgIQgHgIAAgQQAAgIACgGQACgGAEgFQAEgEAFgCQAFgCAGAAIAIABIAHADIABgDIATAAIAAA6QAAAJgCAGQgDAHgEADQgFAEgGABQgHACgHAAIgMgBgAgGgZQgEAFAAAIIAAAHIADAFIADADIAFABIAGgBIAFgCIAAgdIgEgBIgEgBQgHAAgDAFg',
      );
    this.shape_7.setTransform(11.425, -3.525);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAKAiIAAghIAAgHIgBgGIgDgDIgGgBIgEABIgFADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAEgCQAEgDAGAAQAKAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_8.setTransform(4.075, -4.775);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYAdQgGgGAAgJQAAgHADgFQADgDAGgDQAFgDAIgBIAPgBIAAgBQAAgFgDgCQgFgCgHAAIgIABIgKADIgBAAIAAgQIAKgCIANgBQAQAAAIAGQAIAFAAAMIAAAsIgVAAIAAgHIgDADIgFADIgEACIgIABQgIAAgGgGgAACADIgFABQgDABgCACQgBACAAADQAAAFACACQADABAEAAIAFgBIAFgDIAAgOIgIABg',
      );
    this.shape_9.setTransform(-3.625, -4.675);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAKAtIAAggIAAgIIgBgFIgDgDIgGgBIgEABIgFADIAAAtIgVAAIAAhaIAVAAIAAAhQAFgFAEgCQAEgCAGAAQAKAAAFAHQAGAFAAAMIAAAqg',
      );
    this.shape_10.setTransform(-10.825, -5.95);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYAiQgLgMAAgWQAAgUALgMQAMgMASAAIAKAAIAIACIAGACIAGADIAAAVIgCAAIgEgDIgGgEIgGgDIgIgCQgFAAgDACQgDABgEAEQgDADgDAGQgCAGAAAGQAAAIACAGQADAFADAEQAEADADACQAEABAFAAIAIgBIAGgEIAFgDIAEgEIACAAIAAAVIgGADIgGACIgHACIgLAAQgSAAgMgLg',
      );
    this.shape_11.setTransform(-18.7, -5.775);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgRAhIgKgEIAAgRIABAAIAEACIAFADIAGADIAIABQAEAAADgCQADgBAAgDQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBIgGgCIgFgBIgGgCQgIgCgEgEQgEgEAAgIQAAgFACgDQACgEAEgDQAEgDAGgCQAFgCAHAAQAHAAAFACQAGABAEACIAAAQIgBAAIgEgCIgEgCIgGgCIgHgBQgDAAgDACQgBAAgBABQAAAAAAABQgBAAAAABQAAAAAAABQAAAAAAABQAAAAAAABQAAAAABAAQAAABAAAAQACACAEABIAGABIAHACQAHACADADQAEAFAAAHQAAAFgCAEQgCAEgEADQgEADgGACQgGACgHAAQgHAAgHgCg',
      );
    this.shape_12.setTransform(19.525, 9.825);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgZAlQgGgJAAgQQAAgJACgFQACgGAEgFQAEgEAFgDQAFgCAGAAIAHABIAIAEIAAgdIAUAAIAABbIgUAAIAAgHIgFADIgEADIgEACIgGABQgLAAgHgKgAgGgCQgEAFAAAJQAAAKADAEQADAEAFAAQADAAADgBIAFgCIAAggIgEgBIgEAAQgHAAgDAEg',
      );
    this.shape_13.setTransform(12.325, 8.65);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AAKAiIAAghIAAgHIgBgGIgDgDIgGgBIgEABIgFADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAEgCQAEgDAGAAQAKAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_14.setTransform(4.975, 9.725);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgYAcQgGgHAAgMIAAgqIAVAAIAAAhIAAAHIABAGIADACQACACADAAIAFgCIAFgCIAAguIAVAAIAABBIgVAAIAAgIIgKAIQgDACgGAAQgKAAgFgGg',
      );
    this.shape_15.setTransform(-2.775, 9.9);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgYAZQgJgIAAgRQAAgQAJgIQAJgKAPAAQAQAAAJAKQAJAJAAAPQAAARgJAIQgIAKgRAAQgPAAgJgKgAgEgTIgEAEQgCACgBAEIgBAJIABAKIACAGIAFAEIAEABIAFgBIAEgEIADgGIABgKIgBgJIgDgFQgCgDgCgBIgFgBIgEAAg',
      );
    this.shape_16.setTransform(-10.3, 9.8);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AAOAsIgYghIgHAAIAAAhIgWAAIAAhWIAjAAIAMAAQAFABAEADQAFADADAEQADAFAAAHQAAAKgFAGQgEAGgIADIAdAmgAgRgDIAGAAIAIgBIAEgCIADgEIABgGQAAgEgBgCQgBgCgDgBIgEgBIgGAAIgHAAg',
      );
    this.shape_17.setTransform(-17.775, 8.75);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgWAaQgKgJAAgRQAAgOAKgKQAJgKAPAAQAQAAAHAIQAIAJAAAPIAAAGIgsAAIACAIQABADADABQADACACABIAIABIAHgBIAGgCIAFgCIADgCIADAAIAAARIgFABIgGACIgHABIgIABQgSAAgKgJgAgHgRQgEAEAAAFIAYAAQgBgGgCgEQgDgCgGAAQgFAAgDADg',
      );
    this.shape_18.setTransform(19.025, -4.7);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgOAtIgKgCIAAgQIACAAIAEABIAEABIAFABIAFABIAIgBIAFgDQACgCAAgDIABgHIAAgBQgEADgEABQgEACgEAAQgNAAgHgIQgHgIAAgQQAAgIACgGQACgGAEgFQAEgEAFgCQAFgCAGAAIAIABIAHADIABgDIATAAIAAA6QAAAJgCAGQgDAHgEADQgFAEgGABQgHACgHAAIgMgBgAgGgZQgEAFAAAIIAAAHIADAFIADADIAFABIAGgBIAFgCIAAgdIgEgBIgEgBQgHAAgDAFg',
      );
    this.shape_19.setTransform(11.425, -3.525);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AAKAiIAAghIAAgHIgBgGIgDgDIgGgBIgEABIgFADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAEgCQAEgDAGAAQAKAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_20.setTransform(4.075, -4.775);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgYAdQgGgGAAgJQAAgHADgFQADgDAGgDQAFgDAIgBIAPgBIAAgBQAAgFgDgCQgFgCgHAAIgIABIgKADIgBAAIAAgQIAKgCIANgBQAQAAAIAGQAIAFAAAMIAAAsIgVAAIAAgHIgDADIgFADIgEACIgIABQgIAAgGgGgAACADIgFABQgDABgCACQgBACAAADQAAAFACACQADABAEAAIAFgBIAFgDIAAgOIgIABg',
      );
    this.shape_21.setTransform(-3.625, -4.675);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AAKAtIAAggIAAgIIgBgFIgDgDIgGgBIgEABIgFADIAAAtIgVAAIAAhaIAVAAIAAAhQAFgFAEgCQAEgCAGAAQAKAAAFAHQAGAFAAAMIAAAqg',
      );
    this.shape_22.setTransform(-10.825, -5.95);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgYAiQgLgMAAgWQAAgUALgMQAMgMASAAIAKAAIAIACIAGACIAGADIAAAVIgCAAIgEgDIgGgEIgGgDIgIgCQgFAAgDACQgDABgEAEQgDADgDAGQgCAGAAAGQAAAIACAGQADAFADAEQAEADADACQAEABAFAAIAIgBIAGgEIAFgDIAEgEIACAAIAAAVIgGADIgGACIgHACIgLAAQgSAAgMgLg',
      );
    this.shape_23.setTransform(-18.7, -5.775);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .to(
          {
            state: [
              { t: this.shape_23 },
              { t: this.shape_22 },
              { t: this.shape_21 },
              { t: this.shape_20 },
              { t: this.shape_19 },
              { t: this.shape_18 },
              { t: this.shape_17 },
              { t: this.shape_16 },
              { t: this.shape_15 },
              { t: this.shape_14 },
              { t: this.shape_13 },
              { t: this.shape_12 },
            ],
          },
          1,
        )
        .wait(1),
    );

    // Layer 2
    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics.f('#000000').s().p('Aj3ClIAAlJIHuAAIAAFJg');
    this.shape_24.setTransform(-0.05, 2.1);

    this.timeline.addTween(cjs.Tween.get(this.shape_24).wait(2));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-24.8, -15.4, 49.5, 34);

  (lib.redX = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('#FF0000')
      .ss(5, 0, 0, 3)
      .p('ACWCWIiWiWIiVCWAAAAAICWiVAiViVICVCV');
    this.shape.setTransform(0, 0.0029);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.5, -17.5, 35, 35);

  (lib.roundBtnshine = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .lf(
        ['rgba(255,255,255,0)', 'rgba(255,255,255,0.2)'],
        [0, 1],
        0,
        22.5,
        0,
        -22.5,
      )
      .s()
      .p('AiuDhQgyAAAAgyIAAldQAAgyAyAAIFdAAQAyAAAAAyIAAFdQAAAygyAAg');

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-22.5, -22.5, 45, 45);

  (lib.roundBtnhover = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('rgba(255,255,255,0.498)')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape.setTransform(0, 0.025);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(255,255,255,0.098)')
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_1.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtnhover,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.GameFrame_veil = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#FFFFFF').s().p('Eg/RAvqMAAAhfTMB+jAAAMAAABfTg');
    this.shape.setTransform(400, 300);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.GameFrame_veil,
    new cjs.Rectangle(-5, -5, 810, 610),
    null,
  );

  (lib.EndScreenbuttonhover = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(255,255,255,0.098)')
      .s()
      .p(
        'AqJDIQhTAAg7g6Qg6g7AAhTQAAhSA6g7QA7g6BTAAIUTAAQBTAAA6A6QA7A7AABSQAABTg7A7Qg6A6hTAAg',
      );

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.EndScreenbuttonhover,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.EndScreenbuttonbg = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5645DA')
      .s()
      .p(
        'AqJDIQhTAAg7g6Qg6g7AAhTQAAhSA6g7QA7g6BTAAIUTAAQBTAAA6A6QA7A7AABSQAABTg7A7Qg6A6hTAAg',
      );

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.EndScreenbuttonbg,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.buttonSubmitLarge = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // TEXT - Roboto Black copy
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('AgcgcIg2AfIgUgiICZhZIAUAiIg4AgIBYCVIgtAag');
    this.shape.setTransform(45.0674, 2.1086, 1.0094, 1.0094);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f('#FFFFFF').s().p('Ag+hZIAvgTIBODFIgwAUg');
    this.shape_1.setTransform(35.0745, 9.9065, 1.0094, 1.0094);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p('AiDhTIBCgMIBICIIAUiZIBDgNIAmDRIgyAJIgXiVIgXCeIgiAGIhNiLIAgCTIgyAKg');
    this.shape_2.setTransform(17.2841, 14.9788, 1.0094, 1.0094);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAABtIhUgGIAOjUIBLAFQAUACAPAEQARAGAJAHQALAJAEALQAFAKgBAQIgCAOQgCAGgEAGQgEAGgGAEQgHAEgIACQAJADAHAGQAGAEAEAHQADAGACAIQABAIAAAGQgDAggVAOQgSANgdAAIgNgBgAgeBDIAgACQAHABAHgCQAFgBAEgDQAEgEABgEQACgCABgHIgBgLQgBgEgDgFQgDgEgFgCQgGgCgGAAIgjgDgAgZgQIAaABQARABAHgFQAIgGABgLQABgOgIgGQgHgHgRgBIgYgCg',
      );
    this.shape_3.setTransform(-6.6804, 16.0647, 1.0094, 1.0094);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgmBxQgSgGgNgIQgOgJgIgNQgHgLgDgRQgBgQAFgRIAniFIAxAOIgnCFQgFATAGALQAFALAPAEQAPAEALgGQAJgGAGgTIAniFIAxAPIgnCFQgFASgKAMQgJALgOAHQgNAGgPABIgDAAQgOAAgSgFg',
      );
    this.shape_4.setTransform(-25.8088, 11.9274, 1.0094, 1.0094);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgRBsQgPgDgQgJIgSgMQgKgHgGgHQgHgJgEgJQgFgKgCgJQgBgKABgLQADgMAFgIIAuAXQgFAJgBAGQAAAHACAGQACAGAFAEQAGAGAIADQAGAEAFABQAFABAFgBQAFgBADgCIAEgHIADgIQABgFgCgFIgGgLIgNgQIgTgVQgKgNgEgLQgFgMAAgMQAAgNAGgMQAGgLAMgIQALgHANgBQANgCAOAEQAPADAQAJQAQAIAKALQAKALAGANQAFAMgBAOQAAANgHANIgtgYIADgKQABgFgCgGQgBgFgEgEQgFgFgFgDQgGgDgHgCQgFgBgFABQgEABgEACIgFAHQgCAEAAAFQABAFACAFIAHALIAMANQAPAQAGAIQAIAMAEAMQAFAMgBAMQgCAMgGALQgGAMgLAIQgKAIgNABIgIABQgIAAgKgDg',
      );
    this.shape_5.setTransform(-45.3026, 5.2378, 1.0094, 1.0094);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(2),
    );

    // Layer 5 copy
    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#EF8346')
      .s()
      .p(
        'Am4DlQjKhWidiaIEukwQBiBgB+A1QCCA3COAAQCNAACCg3QB/g1BghhIEzEtQidCcjMBWQjSBajmgBQjmAAjRhXg',
      );
    this.shape_6.setTransform(0.2507, 3.6985, 1.0094, 1.0094);

    this.timeline.addTween(cjs.Tween.get(this.shape_6).wait(2));

    // button
    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#D0DA4F')
      .s()
      .p(
        'AlsCTQiohGiCiBICpinQBgBgB9A1QCCA3COAAQCOAACCg3QB9g1BihhICnCnQiBCBipBHQiuBKi+AAQi+AAiuhKg',
      );
    this.shape_7.setTransform(0.4489, -6.4664, 1.0377, 1.0377);
    this.shape_7._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape_7).wait(1).to({ _off: false }, 0).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-80.5, -29.4, 161.5, 65.1);

  (lib.ValueTextBlack_fields = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // line
    this.line = new lib.ValueTextBlack_line();
    this.line.name = 'line';

    this.timeline.addTween(cjs.Tween.get(this.line).wait(1));

    // denominator
    this.denominator = new cjs.Text('1', "bold 20px 'Open Sans Condensed'");
    this.denominator.name = 'denominator';
    this.denominator.textAlign = 'center';
    this.denominator.lineHeight = 29;
    this.denominator.lineWidth = 57;
    this.denominator.parent = this;
    this.denominator.setTransform(0, -4.6);

    this.timeline.addTween(cjs.Tween.get(this.denominator).wait(1));

    // numerator
    this.numerator = new cjs.Text('1', "bold 20px 'Open Sans Condensed'");
    this.numerator.name = 'numerator';
    this.numerator.textAlign = 'center';
    this.numerator.lineHeight = 29;
    this.numerator.lineWidth = 57;
    this.numerator.parent = this;
    this.numerator.setTransform(-0.25, -23.35);

    this.timeline.addTween(cjs.Tween.get(this.numerator).wait(1));

    // extraTinyText
    this.extraTinyText = new cjs.Text('1', "bold 16px 'Open Sans Condensed'");
    this.extraTinyText.name = 'extraTinyText';
    this.extraTinyText.textAlign = 'center';
    this.extraTinyText.lineHeight = 23;
    this.extraTinyText.lineWidth = 57;
    this.extraTinyText.parent = this;
    this.extraTinyText.setTransform(0.1, -12.1);

    this.timeline.addTween(cjs.Tween.get(this.extraTinyText).wait(1));

    // tinyText
    this.tinyText = new cjs.Text('1', "bold 20px 'Open Sans Condensed'");
    this.tinyText.name = 'tinyText';
    this.tinyText.textAlign = 'center';
    this.tinyText.lineHeight = 29;
    this.tinyText.lineWidth = 57;
    this.tinyText.parent = this;
    this.tinyText.setTransform(0, -15.2);

    this.timeline.addTween(cjs.Tween.get(this.tinyText).wait(1));

    // smallText
    this.smallText = new cjs.Text('1', "bold 26px 'Open Sans Condensed'");
    this.smallText.name = 'smallText';
    this.smallText.textAlign = 'center';
    this.smallText.lineHeight = 37;
    this.smallText.lineWidth = 57;
    this.smallText.parent = this;
    this.smallText.setTransform(0, -18.7);

    this.timeline.addTween(cjs.Tween.get(this.smallText).wait(1));

    // largeText
    this.largeText = new cjs.Text('1', "bold 70px 'Open Sans Condensed'");
    this.largeText.name = 'largeText';
    this.largeText.textAlign = 'center';
    this.largeText.lineHeight = 101;
    this.largeText.lineWidth = 83;
    this.largeText.parent = this;
    this.largeText.setTransform(16.7, -22.1);

    this.timeline.addTween(cjs.Tween.get(this.largeText).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.ValueTextBlack_fields,
    new cjs.Rectangle(-30.8, -25.3, 90.8, 106.2),
    null,
  );

  (lib.numberButton = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // Layer_3
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(53.4, 53.35, 3.6514, 3.492, 0, 0, 0, 0.5, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // number
    this.n = new lib.number();
    this.n.name = 'n';
    this.n.setTransform(56.65, 38, 1.1948, 1, 0, 0, 0, 22.4, 52);

    this.timeline.addTween(cjs.Tween.get(this.n).wait(3));

    // frame
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(53.0003, 55.0003, 1.9565, 1.9565);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(3));

    // bg
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f()
      .s('#EF8346')
      .ss(1, 1, 1)
      .p('AwAwAMAgBAAAMAAAAgBMggBAAAg');
    this.shape_1.setTransform(51.475, 53.475);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics.f('#EF8346').s().p('AwAQBMAAAggBMAgBAAAMAAAAgBg');
    this.shape_2.setTransform(51.475, 53.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#D2D966').s().p('AwAQBMAAAggBMAgBAAAMAAAAgBg');
    this.shape_3.setTransform(51.475, 53.475);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [] })
        .to({ state: [{ t: this.shape_2 }, { t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_1 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-59.5, -57.5, 225, 225);

  (lib.mA = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(28, 28.05, 0.8299, 0.8294, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(1));

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'Ag0BlQgSgfAAhGQAAhDASggQARggAjAAQBHAAAACDQAAAngGAeQgHAdgPARQgQARgbAAQgiAAgSgfgAgQhCQgFAWAAAsQAAAuAEAWQAFAWAMgBQANABAFgWQAEgWAAguQAAgrgEgXQgFgWgNgBQgMABgEAWg',
      );
    this.shape.setTransform(35.925, 29.6);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p('AAHCBIAAiWIABguIgFAIIgHAJIgXAXIgcgdIBEhIIArAAIAAEBg');
    this.shape_1.setTransform(17.9, 29.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.mA,
    new cjs.Rectangle(0, 0, 55, 55.9),
    null,
  );

  (lib.m9 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(27, 28.05, 0.8299, 0.8294, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(1));

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AgqCDIgRgCIAAgqQAOAEAQAAQAcAAANgWQAOgWABglIgCAAQgNAdgbABQgbAAgOgYQgOgVAAglQgBgbAJgUQAHgTARgMQAPgLAXAAQAhAAAUAdQASAeABA0QAAAggGAcQgEAcgMAUQgMAVgSAMQgTALgaAAIgRgBgAgRhNQgFAKgBAXQAAArAXAAQAHAAAFgFQAGgHACgIQACgIAAgJIAAgPIgDgQQgDgJgFgGQgEgFgHAAQgKAAgHAMg',
      );
    this.shape.setTransform(27.4, 29.6);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.m9,
    new cjs.Rectangle(0, 0, 55, 55.9),
    null,
  );

  (lib.m8 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(27, 28.05, 0.8299, 0.8294, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(1));

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'Ag1ByQgTgSAAgiQAAgVAJgRQAKgQAVgNQgRgNgIgRQgJgQAAgSQAAgeASgQQASgQAeAAQAgAAASAQQARAQAAAeQAAAUgJAQQgJAQgTAMQAWAOALAQQAKAQAAAUQAAAhgTATQgUATgiAAQgiAAgTgSgAgUAmQgGALAAANQAAAOAHAJQAHAIAMAAQANAAAHgIQAHgIAAgPQAAgLgFgJQgFgKgNgKIgEgFQgOAKgGALgAgOhVQgGAHAAAMQAAALAGAJQAFAJAJAIQAMgJAFgJQAFgIAAgLQAAgMgGgHQgGgHgKAAQgIAAgGAHg',
      );
    this.shape.setTransform(27.475, 29.6);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.m8,
    new cjs.Rectangle(0, 0, 55, 55.9),
    null,
  );

  (lib.m7 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(27, 28.05, 0.8299, 0.8294, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(1));

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p('Ag0CBIBKjWIhdAAIAAgrICPAAIAAAiIhJDfg');
    this.shape.setTransform(27.475, 29.6);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.m7,
    new cjs.Rectangle(0, 0, 55, 55.9),
    null,
  );

  (lib.m6 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(27, 28.05, 0.8299, 0.8294, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(1));

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AgzBnQgTgeAAg1QgBggAFgbQAFgbALgVQALgVASgMQAUgLAbAAQASAAAPADIAAAqIgOgDIgPgBQgbAAgNATQgOAVgBApIABAAQAMgdAbgBQAbAAAPAYQAPAVAAAlQgBAbgHATQgJAUgPAMQgQALgWAAQgiAAgTgdgAgPANQgHAKAAAPQAAAMADAMQADAMAEAJQAGAHAHAAQAKAAAHgLQAFgLAAgYQAAgqgVAAQgLAAgGALg',
      );
    this.shape.setTransform(27.55, 29.6);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.m6,
    new cjs.Rectangle(0, 0, 55, 55.9),
    null,
  );

  (lib.m5 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(27, 28.05, 0.8299, 0.8294, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(1));

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AhDB2IAAgtQAMAHANAEQANAFAMAAQARAAAJgNQAJgMAAgUQAAgpgkAAQgOAAgQAGIgQgLIAIh/IBuAAIAAAqIhGAAIgDA1IAOgCIAKgBQATAAAOAKQAOAKAIASQAIARAAAYQAAAqgVAXQgUAXgpAAQggAAgVgMg',
      );
    this.shape.setTransform(27.575, 29.775);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.m5,
    new cjs.Rectangle(0, 0, 55, 55.9),
    null,
  );

  (lib.m4 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(27, 28.05, 0.8299, 0.8294, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(1));

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AAGCBIAAg0IhUAAIAAgnIBTimIAwAAIAAClIAaAAIAAAoIgaAAIAAA0gAAAguIgFANIgiBGIAsAAIAAg7IABgMIAAgQIABgLIgCAAIgFAPg',
      );
    this.shape.setTransform(27.575, 29.575);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.m4,
    new cjs.Rectangle(0, 0, 55, 55.9),
    null,
  );

  (lib.m3 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(27, 28.05, 0.8299, 0.8294, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(1));

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AgpCCQgOgDgPgHIAAgtQAbAPAaAAQASABAKgKQAJgKAAgRQAAgTgLgJQgLgJgZAAIgNAAIAAgnIANAAQAXgBALgJQALgLAAgRQAAgegcAAQgKAAgKAFQgKAFgLAIIgTgkQAQgMARgGQAQgFAVAAQAeAAARARQASARAAAfQABAVgLAQQgMAQgVAIIAAABQAwAJABAzQgBAjgVAVQgWAUglAAQgRAAgOgCg',
      );
    this.shape.setTransform(27.3, 29.6);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.m3,
    new cjs.Rectangle(0, 0, 55, 55.9),
    null,
  );

  (lib.m2 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(27, 28.05, 0.8299, 0.8294, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(1));

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AhFCCIAAgjIAyhEQAPgWAIgOQAIgOADgMQADgLAAgLQAAgOgHgIQgGgIgMAAQgKAAgJAFQgJAGgKANIgZggQAQgTARgIQAQgHAUAAQAUAAAPAIQAPAJAJAPQAJAQgBAVQAAARgEAPQgDAPgKAQQgKARgQAVIgiAtIAAACIBSAAIAAAqg',
      );
    this.shape.setTransform(27.05, 29.425);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.m2,
    new cjs.Rectangle(0, 0, 55, 55.9),
    null,
  );

  (lib.b90 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.text = new cjs.Text('90', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 70.6);

  (lib.b80 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.text = new cjs.Text('80', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 70.6);

  (lib.b70 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.text = new cjs.Text('70', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 70.6);

  (lib.b60 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.text = new cjs.Text('60', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 70.6);

  (lib.b50 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.text = new cjs.Text('50', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 70.6);

  (lib.b40 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.text = new cjs.Text('40', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 70.6);

  (lib.b30 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.t1 = new cjs.Text('30', "bold 40px 'Open Sans Condensed'");
    this.t1.name = 't1';
    this.t1.textAlign = 'center';
    this.t1.lineHeight = 60;
    this.t1.lineWidth = 50;
    this.t1.parent = this;
    this.t1.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.t1).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 70.6);

  (lib.b20 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.t1 = new cjs.Text('20', "bold 40px 'Open Sans Condensed'");
    this.t1.name = 't1';
    this.t1.textAlign = 'center';
    this.t1.lineHeight = 60;
    this.t1.lineWidth = 50;
    this.t1.parent = this;
    this.t1.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.t1).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 70.6);

  (lib.b18 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.text = new cjs.Text('18', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 70.6);

  (lib.b17 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.text = new cjs.Text('17', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 70.6);

  (lib.b16 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.text = new cjs.Text('16', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, -1.8, 68, 70.2);

  (lib.b15 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.text = new cjs.Text('15', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 70.6);

  (lib.b14 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.text = new cjs.Text('14', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 70.6);

  (lib.b13 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.text = new cjs.Text('13', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 70.6);

  (lib.b12 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.text = new cjs.Text('12', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 70.6);

  (lib.b11 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.text = new cjs.Text('11', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 70.6);

  (lib.b10 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.t1 = new cjs.Text('10', "bold 40px 'Open Sans Condensed'");
    this.t1.name = 't1';
    this.t1.textAlign = 'center';
    this.t1.lineHeight = 60;
    this.t1.lineWidth = 50;
    this.t1.parent = this;
    this.t1.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.t1).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 70.6);

  (lib.b9 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // Layer 2
    this.text = new cjs.Text('9', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 14.0448, 1.0968, 1.0968);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 69);

  (lib.b8 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // Layer 2
    this.text = new cjs.Text('8', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 14.0448, 1.0968, 1.0968);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 69);

  (lib.b7 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // Layer 2
    this.text = new cjs.Text('7', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 14.0448, 1.0968, 1.0968);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 69);

  (lib.b6 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // Layer 2
    this.text = new cjs.Text('6', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 14.0448, 1.0968, 1.0968);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 69);

  (lib.b5 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // Layer 2
    this.text = new cjs.Text('5', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 14.0448, 1.0968, 1.0968);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 69);

  (lib.b4 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // Layer 2
    this.text = new cjs.Text('4', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 14.0448, 1.0968, 1.0968);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 69);

  (lib.b3 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // Layer 2
    this.text = new cjs.Text('3', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 14.0448, 1.0968, 1.0968);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 69);

  (lib.b2 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // Layer 2
    this.text = new cjs.Text('2', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 14.0448, 1.0968, 1.0968);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 69);

  (lib.b1 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // hitArea
    this.ha = new lib.hitArea();
    this.ha.name = 'ha';
    this.ha.setTransform(33.55, 33.5, 1, 1, 0, 0, 0, 0.4, -0.1);

    this.timeline.addTween(cjs.Tween.get(this.ha).wait(3));

    // box
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(33.9994, 33.9994, 0.5913, 0.5913);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(34.0002, 34.0073, 0.5913, 0.5914);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape }] }, 1)
        .wait(1),
    );

    // value
    this.text = new cjs.Text('1', "bold 40px 'Open Sans Condensed'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 60;
    this.text.lineWidth = 50;
    this.text.parent = this;
    this.text.setTransform(34.475, 13.377, 1.1782, 1.1387);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(3));

    // bg
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AksEtIAApZIJZAAIAAJZ');
    this.shape_2.setTransform(34.425, 31.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#FFFFFF').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_3.setTransform(34.425, 32.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AksE7IAAgcIAApZIJZAAIAAJZIAAAcg');
    this.shape_4.setTransform(34.425, 32.85);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('Ak6k6IJ1AAIAAJ1Ip1AAg');
    this.shape_5.setTransform(35.5, 32.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#EF8346').s().p('Ak6E7IAAp1IJ1AAIAAJ1g');
    this.shape_6.setTransform(35.5, 32.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 68, 70.6);

  (lib.OperationButtons = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(4));

    // icon
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('#666666')
      .ss(1, 1, 1)
      .p('AAxgwIBqAAAiaAxIAAhhIBqAAIAAhqIBhAAAgwCbIAAhq');
    this.shape.setTransform(-0.05, 0);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f()
      .s('#CCCCCC')
      .ss(1, 1, 1)
      .p('AAxiaIAABqACbgwIAABhIhqAAIAABqIhhAAAgwAxIhqAA');
    this.shape_1.setTransform(-0.05, 0);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(255,255,255,0.8)')
      .s()
      .p('AgvCbIAAhqIhrAAIAAhhIBrAAIAAhqIBgAAIAABqIBqAAIAABhIhqAAIAABqg');
    this.shape_2.setTransform(-0.05, 0);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f().s('#666666').ss(1, 1, 1).p('AiaAxIAAhhIE1AA');
    this.shape_3.setTransform(-0.05, 0.025);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f().s('#CCCCCC').ss(1, 1, 1).p('ACbgwIAABhIk1AA');
    this.shape_4.setTransform(-0.05, 0.025);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('rgba(255,255,255,0.8)')
      .s()
      .p('AiaAxIAAhhIE1AAIAABhg');
    this.shape_5.setTransform(-0.05, 0.025);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f()
      .s('#CCCCCC')
      .ss(1, 1, 1)
      .p('ACQApIhFBFIhLhLIhKBLIhFhFAhEgiIhLhLACQhtIhLBL');
    this.shape_6.setTransform(0.05, 3.5);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f()
      .s('#666666')
      .ss(1, 1, 1)
      .p('AiPgoIBFhFIBKBLIBLhLIBFBFAiPBuIBLhMABFAiIBLBM');
    this.shape_7.setTransform(0.05, -3.4);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('rgba(255,255,255,0.8)')
      .s()
      .p('AAABFIhKBLIhFhFIBLhLIhLhKIBFhFIBKBLIBLhLIBFBFIhLBKIBLBLIhFBFg');
    this.shape_8.setTransform(0.05, 0.05);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f()
      .s('#666666')
      .ss(1, 1, 1)
      .p(
        'AgZhPQgDgEgDgDQgJgOACgPQADgQAOgJQAMgJAPADQAIABAMAHAgZCUQgDgEgDgDQgJgOACgPQADgQAOgJQAMgJAPADQAIABALAGAiaA1IAAhhIE1AA',
      );
    this.shape_9.setTransform(0, -0.436);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f()
      .s('#CCCCCC')
      .ss(1, 1, 1)
      .p(
        'AAeiQQADAFACAFQADAKgCAKQgCAKgFAHQgDAEgFAEQgNAJgPgDQgHgBgFgDAAdBTQAKAOgDAQQgCAPgNAKQgNAJgPgDQgHgBgFgDACbg4IAABhIk1AA',
      );
    this.shape_10.setTransform(0, 0.761);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('rgba(255,255,255,0.8)')
      .s()
      .p(
        'AgGCYIgNgEIgFgFIgHgHQgJgNACgPQADgQAOgJQAMgJAPACQAIABAKAHIAFAGQAKAPgDAQQgCAPgNAJQgKAHgLAAIgGAAgAiaAwIAAhgIE1AAIAABggAgGhLQgIgCgFgDIgFgEIgHgHQgJgNACgQQADgPAOgJQAMgKAPADQAIABALAIIAFAFIAFAKQADAKgCAKQgCAKgFAHQgDAFgFADQgLAHgKAAIgGAAg',
      );
    this.shape_11.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [{ t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }],
        })
        .to(
          {
            state: [
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_3 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_8 },
              { t: this.shape_7 },
              { t: this.shape_6 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_11 },
              { t: this.shape_10 },
              { t: this.shape_9 },
            ],
          },
          1,
        )
        .wait(1),
    );

    // color
    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .rf(['#A415EA', '#541D67'], [0, 1], -1.9, -8.5, 0, -1.9, -8.5, 40.1)
      .s()
      .p(
        'AiODMQhVg7gRhmQgThlA7hVQA7hUBngSQBkgRBVA7QBVA7ASBmQASBlg8BUQg7BUhlATQgYAEgWAAQhLAAhBgug',
      );
    this.shape_12.setTransform(-0.0061, 0.0189);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .rf(['#1BB448', '#265945'], [0, 1], -1.9, -8.4, 0, -1.9, -8.4, 40)
      .s()
      .p(
        'AiODNQhVg8gShmQgShlA7hUQA8hUBmgTQBkgRBVA7QBUA7ATBmQASBlg8BUQg7BVhmASQgXAEgWAAQhLAAhBgtg',
      );
    this.shape_13.setTransform(0.0146, -0.0135);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .rf(['#351DE2', '#2C2659'], [0, 1], -1.9, -8.6, 0, -1.9, -8.6, 40.1)
      .s()
      .p(
        'AiODMQhVg7gShmQgShlA7hUQA8hWBmgRQBkgSBVA8QBUA7ATBmQARBlg7BUQg8BVhlASQgYAEgWAAQhLAAhAgug',
      );
    this.shape_14.setTransform(0.0045, 0);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .rf(['#FF0000', '#990000'], [0, 1], -1.8, -8.5, 0, -1.8, -8.5, 40.1)
      .s()
      .p(
        'AiODMQhVg7gShmQgShlA8hVQA7hUBmgSQBkgSBVA8QBUA7ATBmQASBlg8BUQg7BUhlATQgYAEgVAAQhMAAhBgug',
      );
    this.shape_15.setTransform(-0.0102, 0.0013);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_12 }] })
        .to({ state: [{ t: this.shape_13 }] }, 1)
        .to({ state: [{ t: this.shape_14 }] }, 1)
        .to({ state: [{ t: this.shape_15 }] }, 1)
        .wait(1),
    );

    // shine
    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .lf(
        ['rgba(255,255,255,0.502)', 'rgba(255,255,255,0)'],
        [0, 0.682],
        0,
        -19.1,
        0,
        19.2,
      )
      .s()
      .p(
        'AiHCHQg4g3AAhQQAAhPA4g4QA5g3BOAAQBPAAA5A3QA4A4AABPQAABQg4A3Qg5A4hPAAQhOAAg5g4g',
      );
    this.shape_16.setTransform(0.15, -2.3);

    this.timeline.addTween(cjs.Tween.get(this.shape_16).wait(4));

    // submitbutton
    this.submitButton = new lib.buttonSubmitLarge();
    this.submitButton.name = 'submitButton';
    this.submitButton.setTransform(
      -0.15,
      36.85,
      0.5049,
      0.4819,
      0,
      0,
      0,
      0.2,
      -6.1,
    );

    this.timeline.addTween(cjs.Tween.get(this.submitButton).wait(4));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-40.9, -25, 81.6, 82);

  (lib.Scoreboard_progressMeter = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // outline
    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#003366').ss(2, 1, 1).p('AvniVIfPAAIAAErI/PAAg');
    this.shape.setTransform(100, 0);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // fill
    this.percentCompleteTxt = new cjs.Text('', "bold 14px 'Roboto'", '#FFFFFF');
    this.percentCompleteTxt.name = 'percentCompleteTxt';
    this.percentCompleteTxt.lineHeight = 19;
    this.percentCompleteTxt.lineWidth = 28;
    this.percentCompleteTxt.parent = this;
    this.percentCompleteTxt.setTransform(205, -9.25, 1, 1.0024);

    this.progressMeterFill = new lib.Scoreboard_progressMeter_fill();
    this.progressMeterFill.name = 'progressMeterFill';
    this.progressMeterFill.setTransform(100, 0, 1, 1, 0, 0, 0, 100, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.progressMeterFill },
            { t: this.percentCompleteTxt },
          ],
        })
        .wait(1),
    );

    // Layer 2
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f()
      .s('#003366')
      .ss(2, 1, 1)
      .p('AvniVIfPAAIAAErI/PAAg');
    this.shape_1.setTransform(100, 0);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(0,51,102,0.047)')
      .s()
      .p('AvnCWIAAkrIfPAAIAAErg');
    this.shape_2.setTransform(100, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }, { t: this.shape_1 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Scoreboard_progressMeter,
    new cjs.Rectangle(-1, -16, 235.9, 32),
    null,
  );

  (lib.Scoreboard_muteBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.instance = new lib.redX('synched', 0);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(2),
    );

    // Layer_3
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#333333')
      .s()
      .p(
        'AACCOQAzhOgBhAQABhAgzhNIAMgIQA3BLABBKQgBBKg3BMgAgoBxQAqg2AAg7QAAg6gqg2IALgJQAXAZAMAgQANAiAAAeQAABBgvA4gAhEBSQAZghAAgxQABgpgXgjIgDgGIAMgIQAfApAAAxQAAAygfAog',
      );
    this.shape.setTransform(11.05, 0);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#666666')
      .s()
      .p(
        'AACCOQAzhOgBhAQABhAgzhNIAMgIQA3BLABBKQgBBKg3BMgAgoBxQAqg2AAg7QAAg6gqg2IALgJQAXAZAMAgQANAiAAAeQAABBgvA4gAhEBSQAZghAAgxQABgpgXgjIgDgGIAMgIQAfApAAAxQAAAygfAog',
      );
    this.shape_1.setTransform(11.05, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [] }, 2)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // Layer_1
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#333333')
      .s()
      .p('AgNAzIAAhlIBehOIAAEBgAhQAuIAAhbIAyAAIAABbg');
    this.shape_2.setTransform(-8.225, 0.025);

    this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(4));

    // Layer_4
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AilDLQhFhUAAh3QAAh2BFhUQBEhUBhAAQBhAABFBUQBFBUAAB2QAAB3hFBUQhFBUhhAAQhhAAhEhUg',
      );
    this.shape_3.setTransform(0.0244, -0.0169, 0.8511, 0.6969);

    this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(4));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-20, -20, 40, 40);

  (lib.Scoreboard_musicBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.instance = new lib.redX('synched', 0);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(2),
    );

    // Layer_7
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CCCCCC')
      .s()
      .p(
        'AieAZQAAgbAfgWIAMAFIgEADQgWARAAAYQAAAbAaATIgMAEQgfgWAAgcgAB0AUQAagSAAgaQAAgYgWgSIgEgEIAMgEQAfAWAAAcQAAAbgfAWg',
      );
    this.shape.setTransform(-0.475, 7.5);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(3).to({ _off: false }, 0).wait(1),
    );

    // Layer_5
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#333333')
      .s()
      .p(
        'AhiCOQgKgHABgNQAAgVATgRQATgQAYAAQAMAAAJAEIAAi5ICFgkIAADUQAAAWgUAQQgTARgYAAQgPAAgKgIQgIgHgBgOQAAgUAUgRQATgRAYAAQANAAAIAGIAAiYIhsAcIAACzQAAAUgTARQgUARgWAAQgRAAgIgIg',
      );
    this.shape_1.setTransform(-1.05, -1.45);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#CCCCCC')
      .s()
      .p(
        'AhiCOQgKgHABgNQAAgVATgRQATgQAYAAQAMAAAJAEIAAi5ICFgkIAADUQAAAWgUAQQgTARgYAAQgPAAgKgIQgIgHgBgOQAAgUAUgRQATgRAYAAQANAAAIAGIAAiYIhsAcIAACzQAAAUgTARQgUARgWAAQgRAAgIgIg',
      );
    this.shape_2.setTransform(-1.05, -1.45);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }] })
        .to({ state: [{ t: this.shape_2 }] }, 2)
        .wait(2),
    );

    // Layer_4
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AilDLQhFhUAAh3QAAh2BFhUQBEhUBhAAQBhAABFBUQBFBUAAB2QAAB3hFBUQhFBUhhAAQhhAAhEhUg',
      );
    this.shape_3.setTransform(0.0244, -0.0169, 0.8511, 0.6969);

    this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(4));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-20, -20, 40, 40);

  (lib.ProgressPanel = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.correctTxt = new cjs.Text('', "bold 16px 'Roboto'", '#FFFFFF');
    this.correctTxt.name = 'correctTxt';
    this.correctTxt.lineHeight = 21;
    this.correctTxt.lineWidth = 28;
    this.correctTxt.parent = this;
    this.correctTxt.setTransform(273.65, -8.9, 1, 1.0024);

    this.roundTxt = new cjs.Text('', "bold 16px 'Roboto'", '#FFFFFF');
    this.roundTxt.name = 'roundTxt';
    this.roundTxt.lineHeight = 21;
    this.roundTxt.lineWidth = 20;
    this.roundTxt.parent = this;
    this.roundTxt.setTransform(68.05, -8.2856, 1, 1.0024);

    this.gameTxt = new cjs.Text('', "bold 16px 'Roboto'", '#FFFFFF');
    this.gameTxt.name = 'gameTxt';
    this.gameTxt.lineHeight = 21;
    this.gameTxt.lineWidth = 25;
    this.gameTxt.parent = this;
    this.gameTxt.setTransform(156.25, -8.3, 1, 1.0024);

    this.correctLbl = new cjs.Text('Correct:', "bold 15px 'Roboto'", '#FFFFFF');
    this.correctLbl.name = 'correctLbl';
    this.correctLbl.lineHeight = 20;
    this.correctLbl.lineWidth = 57;
    this.correctLbl.parent = this;
    this.correctLbl.setTransform(203.9, -8.45, 1.0021, 0.9976);

    this.bonusTxt = new cjs.Text('', "bold 16px 'Roboto'", '#FFFFFF');
    this.bonusTxt.name = 'bonusTxt';
    this.bonusTxt.lineHeight = 21;
    this.bonusTxt.lineWidth = 48;
    this.bonusTxt.parent = this;
    this.bonusTxt.setTransform(537.5, -9.3, 1, 1.0024);

    this.progressMeterMc = new lib.Scoreboard_progressMeter();
    this.progressMeterMc.name = 'progressMeterMc';
    this.progressMeterMc.setTransform(290.15, -0.7, 1, 1, 0, 0, 0, 100, -0.5);

    this.bonusLbl = new cjs.Text(
      'Bonus \nStickers:  ',
      "bold 12px 'Roboto'",
      '#FFFFFF',
    );
    this.bonusLbl.name = 'bonusLbl';
    this.bonusLbl.textAlign = 'center';
    this.bonusLbl.lineHeight = 12;
    this.bonusLbl.lineWidth = 68;
    this.bonusLbl.parent = this;
    this.bonusLbl.setTransform(493.55, -13.2, 1.0014, 0.9976);

    this.gameLbl = new cjs.Text('GAME:  ', "bold 14px 'Roboto'", '#FFFFFF');
    this.gameLbl.name = 'gameLbl';
    this.gameLbl.lineHeight = 19;
    this.gameLbl.lineWidth = 45;
    this.gameLbl.parent = this;
    this.gameLbl.setTransform(98.5, -7.45, 1.0021, 0.9976);

    this.roundLbl = new cjs.Text('ROUND:', "bold 14px 'Roboto'", '#FFFFFF');
    this.roundLbl.name = 'roundLbl';
    this.roundLbl.lineHeight = 19;
    this.roundLbl.lineWidth = 54;
    this.roundLbl.parent = this;
    this.roundLbl.setTransform(1, -7.45, 1.0021, 0.9976);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.roundLbl },
            { t: this.gameLbl },
            { t: this.bonusLbl },
            { t: this.progressMeterMc },
            { t: this.bonusTxt },
            { t: this.correctLbl },
            { t: this.gameTxt },
            { t: this.roundTxt },
            { t: this.correctTxt },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.ProgressPanel,
    new cjs.Rectangle(-1, -16.2, 588, 32),
    null,
  );

  (lib.roundBtn4 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAjCSIgVAAIAAgwIAAgUIh3AAIgUAAIAAg3ICHioIBMAAIAAAUIAACWIAVAAIATAAIAAAUIAAAhIgoAAIAABEgAhFAZIAkAAIAvAAIAAg8IAAgtg',
      );
    this.shape.setTransform(-0.15, -0.5);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AAPCSIAAgUIAzAAIAAhEIAoAAIAAghIAUAAIAAA1IgnAAIAABEgAh9BOIAAgUIB4AAIAAAUgABCAFIAAiWIAVAAIAACWgAhZAFIBUhpIAAAtIgwA8g',
      );
    this.shape_1.setTransform(1.85, 1.5);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_2.setTransform(0, 0.025);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .rf(['#FF0000', '#990000'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn4,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.roundBtn3 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AhICQQgagGgQgHIAMADQAaAFAkAAQAgAAAVgGQAWgHARgMQAQgNAJgSQAIgRAAgVQAAgSgGgLQgGgLgJgHIgKgHQAJABAKAEQAMAEAJAHQAJAIAGALQAGALAAASQAAAVgIARQgJASgQANQgRAMgWAHQgWAGgfAAQgkAAgagFgAArgOQgLgEgKgBIAAgDQAZgFAPgTQAPgUAAgYQAAgSgIgOQgIgNgQgKIgFgDIABAAQAVAFANAIQAQAKAIANQAIAOAAASQAAAYgPAUQgPATgZAFIAAACIgJgEgAhqhHIAAgWIATgGQAWgHASAAIASABQAKACAIADIAHAFIgNgBQgSAAgWAHQgVAGgUAMg',
      );
    this.shape.setTransform(2.825, 0.6875);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AgnAgIgRgHIAAgBIAHAAQAKAGANAFIgNgDgAA0gYIgZAAIgQAAIAAgKIALAAQANAAAKADQAHACAFAFIgFAAg',
      );
    this.shape_1.setTransform(-2.9375, 4.95);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhICSIgMgDQgSgFgMgFIAAhAIAIAAQAKAGAMAFIASAHIAMADQAQAFAPAAQALAAAMgCQANgCAKgGQAHgGAEgHQAEgGAAgOQAAgMgFgHIgEgDQgFgFgHgCQgJgDgNAAIgLAAIgOAAIgQAAIAAgzIARAAIAbgBQAKgBAJgEQAIgEAEgGQAFgGAAgMQAAgJgFgFIgEgEIgHgEQgIgEgKgCIgRAAQgSAAgWAGIgTAGQgLAFgLAHIgIAAIAAg/QARgGAbgHQAcgFAcAAQAaAAAVAEQARAEAMAGIAFADQAQAKAIANQAIAOAAATQAAAXgPAUQgPATgZAFIAAADQAKABALAEIAJADIACABIAKAHQAJAJAGALQAGAKAAATQAAAUgIASQgJARgQANQgRANgWAGQgWAGgfAAQgkABgagGg',
      );
    this.shape_2.setTransform(-0.175, -0.55);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [{ t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }],
        })
        .wait(1),
    );

    // Layer 4
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .rf(['#351DE2', '#2C2659'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_4.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn3,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.roundBtn2 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AhxCLIAAgUIDPAAIAAgkIAUAAIAAA4gAgjA/IAZgUQARgNASgQQAcgaAOgZQAOgZAAgbQAAgdgNgUIAEAEQAdAXAAAqQAAAcgOAYQgOAYgcAaQgRARgSANgAhphKIAAgcQALgGAMgFQATgHASAAQAYgBANALQAHAGACAIQgKgFgQAAQgSABgTAHQgUAIgRALg',
      );
    this.shape.setTransform(2.625, 2.15);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhdCUIgUAAIAAgwQAagTAagVQAbgVAPgQQAXgXAKgQQAKgRAAgQQAAgKgDgHQgDgIgHgGQgMgLgYAAQgSAAgTAIQgMAEgLAGIgOAJIgGAAIAAhBQANgGAcgGQAagGAcAAQA1AAAdAXQAJAHAHAJQANAUAAAdQAAAbgOAZQgOAYgcAaQgSARgSANIgYAUIAtAAIBUAAIAAAUIAAAjg',
      );
    this.shape_1.setTransform(0.625, -0.825);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_2.setTransform(0, 0.025);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .rf(['#1BB448', '#265945'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn2,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.roundBtn1 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AhgCSIAAgUICtAAIAAgfIAUAAIAAAzgAARBLIAAjcIAUAAIAADcgAhgg6IAAgUIApAAIAAAUg',
      );
    this.shape.setTransform(1.5, 1.425);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhMCSIgUAAIAAgzIA9AAIAAiFIAAgUIgpAAIgUAAIAAgvQAOAAANgCQANgCAJgEQAJgFAFgHQAGgIABgMIA/AAIAAAUIAADcIAUAAIAoAAIAAAUIAAAfg',
      );
    this.shape_1.setTransform(-0.5, -0.575);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_2.setTransform(0, 0.025);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .rf(['#A415EA', '#541D67'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn1,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.nextBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgOBZIgNgFIgNgGQgFgDgEgGIAPgUQAGAGAHAEQAIAEAJAAQANAAAIgHQAHgHAAgNIAAgHQgGAGgHADQgIAEgJAAQgLAAgKgFQgKgFgGgJQgHgIgDgMQgEgLAAgOIAAgCQAAgOAEgMQADgMAHgIQAGgKAKgEQAKgFALABQALgBAHAEQAJAEAFAGIACgMIAeAAIAAB6QAAANgEAKQgFALgIAGQgIAIgLADQgLAEgNAAIgMgBgAgIg6QgGADgCAEQgEAFgCAHQgBAIAAAHIAAACQAAAJABAGQACAGAEAFQACAFAGADQAEACAGAAQAIAAAFgCQAGgDADgGIAAg1QgDgFgGgDQgFgDgIAAQgFAAgFADg',
      );
    this.shape.setTransform(62.3, 4.25);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAVBAIAAhQQAAgFgCgFQgBgDgDgDIgGgDIgJgBQgGAAgFADQgGADgDAGIAABYIgiAAIAAh+IAgAAIABAQQAHgJAJgEQAIgFALABQAJgBAIADQAHADAFAFQAGAGADAJQADAKAAANIAABPg',
      );
    this.shape_1.setTransform(48.975, 1.75);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgQBYIAAh+IAhAAIAAB+gAgHg2QgDgBgDgCIgEgGIgBgHQAAgIAFgFQAFgEAIgBIAIACIAGADQACADACADIABAHIgBAHIgEAGQgDACgDABQgEABgEAAQgDAAgEgBg',
      );
    this.shape_2.setTransform(39.125, -0.65);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgjBZIgDgBIgEAAIgDgBIAAgaIACAAIADAAIAIgBIAHgBIAEgFIADgGIAEgJIgth/IAlAAIAWBPIAYhPIAkAAIgzCRIgEALQgDAFgEAFQgFAFgGADQgHADgKAAIgFAAg',
      );
    this.shape_3.setTransform(29.925, 4.4);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgdA/QgIgDgGgFQgGgFgDgHQgDgHAAgIQAAgKADgIQAEgIAHgEQAIgGALgCQALgDANAAIAPAAIAAgHQAAgJgEgGQgFgFgIAAQgJAAgFAEQgFAEAAAIIghAAQAAgJADgHQAEgHAHgGQAHgFAKgEQAKgDALAAQALAAAKADQAJADAHAFQAHAGAEAIQADAJAAALIAAA0IABAKIABAIIABAGIACAFIAAACIgiAAQgCgEgBgHQgFAGgIAEQgHAEgLAAQgJAAgIgDgAgHAHQgFACgDACQgDADgCADQgBAEAAAEQAAAGAEAFQAEAEAIAAIAHgBIAHgDIAFgEIADgFIAAgVIgOAAQgFAAgFABg',
      );
    this.shape_4.setTransform(17.475, 1.875);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics.f('#FFFFFF').s().p('AgQBaIAAizIAhAAIAACzg');
    this.shape_5.setTransform(7.95, -0.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ag4BZIAAivIAfAAIABANQAGgIAJgDQAHgEAKAAQAMAAAJAFQAJAEAHAIQAFAJAEAMQADAMAAAOIAAADQAAAOgDALQgEALgFAJQgHAJgJAEQgJAGgMAAQgJgBgIgDQgIgEgFgGIAAA8gAgOg5QgFACgDAHIAAAyQADAHAFADQAFADAJAAQAGAAAEgDQAFgDADgFQADgEABgHQACgHAAgHIAAgDQAAgHgCgHQgCgHgCgFQgDgFgFgDQgFgDgFAAQgJAAgFAEg',
      );
    this.shape_6.setTransform(-1.75, 4.2);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ag4BZIAAivIAgAAIABANQAGgIAHgDQAIgEAJAAQANAAAJAFQAKAEAFAIQAHAJADAMQADAMAAAOIAAADQAAAOgDALQgDALgHAJQgFAJgKAEQgJAGgMAAQgJgBgIgDQgHgEgGgGIAAA8gAgOg5QgFACgDAHIAAAyQADAHAFADQAGADAIAAQAFAAAGgDQAEgDADgFQACgEACgHQABgHAAgHIAAgDQAAgHgBgHQgBgHgEgFQgDgFgEgDQgFgDgFAAQgIAAgGAEg',
      );
    this.shape_7.setTransform(-21.25, 4.2);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgUA9QgLgFgJgIQgIgJgEgLQgFgLABgNIAAgEQAAgOADgMQAFgMAHgIQAIgJALgFQALgFAMAAQAPAAAKAFQAKAEAIAIQAGAIAEAMQADALAAAOIAAAOIhPAAQAAAGADAFQADAFAEAEQAEADAFACQAEACAHAAQAJAAAIgDQAHgEAGgHIARATQgDAEgFAEIgLAIIgNAFQgJACgIAAQgOAAgMgFgAgHgjQgEABgEAEQgDADgBAFIgDALIAuAAIAAgDIgBgJQgCgFgDgDQgCgDgFgCQgDgBgHAAQgEAAgEACg',
      );
    this.shape_8.setTransform(-34.6, 1.875);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgUA9QgMgFgIgIQgIgJgEgLQgFgLABgNIAAgEQAAgOADgMQAFgMAIgIQAHgJALgFQALgFAMAAQAOAAALAFQAKAEAHAIQAHAIAEAMQAEALAAAOIAAAOIhQAAQAAAGADAFQADAFAEAEQAEADAFACQAEACAGAAQAKAAAIgDQAHgEAGgHIARATQgDAEgFAEIgLAIIgNAFQgJACgIAAQgOAAgMgFgAgHgjQgFABgDAEQgCADgCAFIgDALIAuAAIAAgDIgBgJQgCgFgDgDQgCgDgFgCQgDgBgHAAQgEAAgEACg',
      );
    this.shape_9.setTransform(-47.55, 1.875);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#FFFFFF')
      .s()
      .p('AAcBVIgrhEIgSAUIAAAwIgkAAIAAipIAkAAIAABNIAPgVIArg4IArAAIg9BLIA/Beg');
    this.shape_10.setTransform(-60.925, -0.325);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer 3
    this.btnHover = new lib.EndScreenbuttonhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 2
    this.instance = new lib.EndScreenbuttonbg();

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.nextBtn,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.moreBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 3
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgUA9QgLgFgJgIQgIgJgEgLQgEgLAAgNIAAgEQAAgOADgMQAFgMAIgIQAHgJALgFQALgFAMAAQAOAAALAFQAKAEAHAIQAIAIADAMQAEALAAAOIAAAOIhQAAQAAAGADAFQACAFAFAEQAEADAFACQAEACAGAAQAKAAAHgDQAJgEAFgHIARATQgDAEgFAEIgLAIIgNAFQgIACgJAAQgOAAgMgFgAgHgjQgEABgDAEQgEADgBAFIgDALIAuAAIAAgDIgBgJQgBgFgEgDQgCgDgEgCQgFgBgGAAQgEAAgEACg',
      );
    this.shape.setTransform(22.75, 1.875);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AA5BAIAAhPQAAgHgBgEQgCgEgDgCQgCgDgEAAIgHgBQgIAAgGAEQgFAEgDAGIAAACIAAABIAABTIggAAIAAhPQAAgHgCgEQAAgDgDgDIgGgDIgJgBQgHAAgFADQgFADgDAGIAABYIgiAAIAAh+IAgAAIABAPQAGgIAKgEQAIgFAMABQAMgBAIAFQAIAEAFALQAGgJAJgGQAKgEANAAQAJgBAIADQAHADAGAFQAFAGADAKQADAIAAAOIAABPg',
      );
    this.shape_1.setTransform(5.75, 1.75);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYA9QgMgFgHgJQgIgIgEgMQgEgMAAgOIAAgBQAAgOAEgMQAEgMAIgIQAHgJALgFQAMgFANAAQAOAAAMAFQALAFAIAJQAHAIAEAMQAEAMAAAOIAAABQAAAOgEAMQgEAMgHAIQgIAJgLAFQgLAFgPAAQgNAAgLgFgAgLgiQgFADgDAFQgDAFgCAHQgBAGAAAIIAAABQAAAIABAHQACAGADAGQADAEAFADQAFADAGAAQAHAAAFgDQAFgDADgEQADgGACgGQABgHAAgIIAAgBQAAgIgBgGQgCgHgDgFQgDgFgFgDQgFgDgHAAQgGAAgFADg',
      );
    this.shape_2.setTransform(-11.425, 1.875);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p('AAjBVIAAhJIhEAAIAABJIgkAAIAAipIAkAAIAABFIBEAAIAAhFIAjAAIAACpg');
    this.shape_3.setTransform(-26.7, -0.325);

    this.btnHover = new lib.EndScreenbuttonhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.btnHover },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer 2
    this.instance = new lib.EndScreenbuttonbg();

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.moreBtn,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.continueBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('Ag1BQIAAifIBqAAIAAAeIhBAAIAAAfIA9AAIAAAdIg9AAIAABFg');
    this.shape.setTransform(66.3, -0.6);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p('AgqBQIAAgcIAXAAIAAhnIgXAAIAAgcIBVAAIAAAcIgXAAIAABnIAXAAIAAAcg');
    this.shape_1.setTransform(53.975, -0.6);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p('AgUBQIg3ifIAqAAIAiBrIAihrIApAAIg3Cfg');
    this.shape_2.setTransform(41.225, -0.6);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgoAwQgTgRAAgeQAAgcARgSQARgSAeAAQAcAAANAPQAOAPAAAcIAAANIhRAAQAAAIADAGQAEAFAEAEQAFADAFABQAHACAIAAIAMgCIAMgDIAIgFIAHgEIAEAAIAAAfIgIADIgLAEIgNACIgQABQggAAgSgQgAgPggQgFAHgBALIAsAAQAAgMgGgGQgEgGgMAAQgJAAgHAGg',
      );
    this.shape_3.setTransform(20.85, 1.325);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AguAyQgJgLgBgWIAAhOIAmAAIAAA7IABAPQAAAGACAEQACAEADACQAEABAGAAQAEAAAFgBIAKgGIAAhUIAmAAIAAB3IgmAAIAAgNQgKAJgIADQgIAFgLAAQgRAAgLgMg',
      );
    this.shape_4.setTransform(7.2, 1.55);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AASA+IAAg8IAAgOQgBgGgBgEQgCgEgEgCQgEgCgGAAIgIACQgEABgGAEIAABVIglAAIAAh4IAlAAIAAAOQAJgIAJgFQAHgEALAAQATAAAJALQALAMgBAWIAABOg',
      );
    this.shape_5.setTransform(-6.8, 1.2);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p('AgSBTIAAh3IAlAAIAAB3gAgTg1IAAgdIAnAAIAAAdg');
    this.shape_6.setTransform(-17.225, -0.95);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgTBFQgKgJAAgWIAAg3IgOAAIAAgaIAOAAIAAgjIAkAAIAAAjIAlAAIAAAaIglAAIAAAqIABALQAAAEABAEQACAEAEACQAEACAHAAIAIgBIAHgCIADAAIAAAaIgNADIgRABQgWAAgLgKg',
      );
    this.shape_7.setTransform(-25.05, -0.225);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AATA+IAAg8IgBgOQgBgGgBgEQgCgEgEgCQgEgCgFAAIgJACQgEABgGAEIAABVIgmAAIAAh4IAmAAIAAAOQAJgIAJgFQAIgEALAAQASAAAKALQAKAMgBAWIAABOg',
      );
    this.shape_8.setTransform(-36.7, 1.2);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgtAvQgQgRAAgeQAAgdAQgRQARgRAcAAQAeAAAQARQAQARAAAdQAAAegQARQgQARgeAAQgcAAgRgRgAgIgjQgEACgEAEQgDAFgCAHQgCAHAAAKQAAALACAHIAFALQADAEAEACQAFACAEAAQAFAAAFgCQAEgCADgEQADgEACgHQACgGAAgMQAAgKgCgHQgCgHgDgEQgDgFgEgBQgEgCgGAAQgEAAgEABg',
      );
    this.shape_9.setTransform(-50.625, 1.375);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgsA+QgVgXAAgnQAAglAVgXQAVgWAjAAIARABIAPADIAMAFIAKAEIAAAmIgEAAIgHgFIgKgIQgGgEgGgCQgHgCgIAAQgIAAgIACQgFADgHAHQgGAGgEAKQgEALAAAOQAAAOAEALQAEAJAHAHQAGAGAGACQAIADAIAAQAHAAAIgDQAHgCAFgDIAJgHIAHgGIAEAAIAAAmIgKAEIgMAFIgOADIgSABQgjAAgVgVg',
      );
    this.shape_10.setTransform(-64.75, -0.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer 3
    this.btnHover = new lib.EndScreenbuttonhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 2
    this.instance = new lib.EndScreenbuttonbg();

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.continueBtn,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.EndScreen = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 2
    this.stickersText = new cjs.Text(
      'Congratulations!',
      "bold 32px 'Roboto'",
      '#003399',
    );
    this.stickersText.name = 'stickersText';
    this.stickersText.textAlign = 'center';
    this.stickersText.lineHeight = 44;
    this.stickersText.lineWidth = 498;
    this.stickersText.parent = this;
    this.stickersText.setTransform(396.95, 319.5);

    this.beforeScoreText = new cjs.Text(
      'You scored',
      "bold 30px 'Roboto'",
      '#003399',
    );
    this.beforeScoreText.name = 'beforeScoreText';
    this.beforeScoreText.textAlign = 'center';
    this.beforeScoreText.lineHeight = 42;
    this.beforeScoreText.lineWidth = 451;
    this.beforeScoreText.parent = this;
    this.beforeScoreText.setTransform(401.5, 121.35);

    this.pointsText = new cjs.Text('0', "bold 60px 'Roboto'", '#003399');
    this.pointsText.name = 'pointsText';
    this.pointsText.textAlign = 'center';
    this.pointsText.lineHeight = 78;
    this.pointsText.lineWidth = 196;
    this.pointsText.parent = this;
    this.pointsText.setTransform(400.95, 144.8);

    this.afterScoreText = new cjs.Text(
      'points',
      "bold 30px 'Roboto'",
      '#003399',
    );
    this.afterScoreText.name = 'afterScoreText';
    this.afterScoreText.textAlign = 'center';
    this.afterScoreText.lineHeight = 42;
    this.afterScoreText.lineWidth = 488;
    this.afterScoreText.parent = this;
    this.afterScoreText.setTransform(401.95, 203.7);

    this.messageText = new cjs.Text(
      'Congratulations!',
      "bold 40px 'Roboto'",
      '#003399',
    );
    this.messageText.name = 'messageText';
    this.messageText.textAlign = 'center';
    this.messageText.lineHeight = 54;
    this.messageText.lineWidth = 498;
    this.messageText.parent = this;
    this.messageText.setTransform(396.95, 243.95);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.messageText },
            { t: this.afterScoreText },
            { t: this.pointsText },
            { t: this.beforeScoreText },
            { t: this.stickersText },
          ],
        })
        .wait(1),
    );

    // Layer 4
    this.continueBtn = new lib.continueBtn();
    this.continueBtn.name = 'continueBtn';
    this.continueBtn.setTransform(424.95, 421);

    this.moreBtn = new lib.moreBtn();
    this.moreBtn.name = 'moreBtn';
    this.moreBtn.setTransform(586.1, 421, 0.7647, 1);

    this.nextBtn = new lib.nextBtn();
    this.nextBtn.name = 'nextBtn';
    this.nextBtn.setTransform(242.05, 421);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.nextBtn },
            { t: this.moreBtn },
            { t: this.continueBtn },
          ],
        })
        .wait(1),
    );

    // bg
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'EgmRAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBMjAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape.setTransform(400, 275);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // shadow
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.098)')
      .s()
      .p(
        'EgmRAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBMjAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_1.setTransform(405, 280);

    this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

    // veil
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(255,255,255,0.498)')
      .s()
      .p('Eg+fAu4MAAAhdvMB8/AAAMAAABdvg');
    this.shape_2.setTransform(400, 300);

    this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.EndScreen,
    new cjs.Rectangle(0, 0, 800, 600),
    null,
  );

  (lib.comsuntexsymbolsValueTextBlack = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // fields
    this.fields = new lib.ValueTextBlack_fields();
    this.fields.name = 'fields';
    this.fields.setTransform(0.25, 0);

    this.timeline.addTween(cjs.Tween.get(this.fields).wait(1));

    // glow
    this.textGlow = new lib.ValueText_glow();
    this.textGlow.name = 'textGlow';

    this.timeline.addTween(cjs.Tween.get(this.textGlow).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsValueTextBlack,
    new cjs.Rectangle(-30.5, -30, 90.8, 110.9),
    null,
  );

  (lib.start = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = { button: 0 };
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('AgNA1IAAhSIgXAAIAAgXIBJAAIAAAXIgXAAIAABSg');
    this.shape.setTransform(134.825, -103.475);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAKA1IgZgpIAAApIgcAAIAAhpIArAAQAIAAAGACQAHACAEAFQAJAKAAAOQAAAHgDAGQgCAGgFADQgEAFgJACIAiArgAgPgFIAEAAQAIAAAEgCIADgFIABgGIgBgGIgDgEQgEgDgIAAIgEAAg',
      );
    this.shape_1.setTransform(126.55, -103.475);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p('AAaA1IgHgSIglAAIgHASIgeAAIAphpIAeAAIAoBpgAgKAOIAWAAIgMghg');
    this.shape_2.setTransform(115.325, -103.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p('AgNA1IAAhSIgXAAIAAgXIBJAAIAAAXIgXAAIAABSg');
    this.shape_3.setTransform(106.525, -103.475);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgmAsIAMgXQAMALAMAAQAGAAAEgEQACgDAAgDQAAgFgDgCQgEgDgIgDQgQgEgFgEQgIgGAAgOQAAgRALgKQAKgJAOAAQASAAAQAJIgLAVQgJgHgJAAQgGAAgCADQgDADAAADQAAAFAGADIAMAEQAOAEAGAHQAGAGAAALQAAAWgNAJQgMAIgPAAQgUAAgRgMg',
      );
    this.shape_4.setTransform(98.175, -103.45);

    this.clockDisplay = new lib.comsuntexsymbolsValueTextBlack();
    this.clockDisplay.name = 'clockDisplay';
    this.clockDisplay.setTransform(127.5, -79.55, 1, 1, 0, 0, 0, 12.6, 23.9);
    this.clockDisplay.alpha = 0.3984;

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .to({ state: [{ t: this.clockDisplay }] }, 1)
        .wait(1),
    );

    // Layer 3
    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics.f('#336633').s().p('AluCeIAAk6ILdAAIAAE6g');
    this.shape_5.setTransform(115.75, -103.25);

    this.timeline.addTween(cjs.Tween.get(this.shape_5).wait(2));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(
    79,
    -133.4,
    96.19999999999999,
    110.80000000000001,
  );

  (lib.OperationAndValue = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // value
    this.v = new lib.comsuntexsymbolsValueTextBlack();
    this.v.name = 'v';
    this.v.setTransform(-18.05, -89.05, 1, 1, 0, 0, 0, -0.1, 23.9);

    this.timeline.addTween(cjs.Tween.get(this.v).wait(1));

    // operations
    this.opBtn = new lib.OperationButtons();
    this.opBtn.name = 'opBtn';
    this.opBtn.setTransform(0, 84, 2, 2);

    this.timeline.addTween(cjs.Tween.get(this.opBtn).wait(1));

    // bkgd
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('#FFFFFF')
      .ss(4, 1, 1)
      .p(
        'AJIAAQAADyirCrQirCrjyAAQjxAAirirQirirAAjyQAAjxCrirQCrirDxAAQDyAACrCrQCrCrAADxg',
      );
    this.shape.setTransform(0.0371, -81.0129, 0.9, 0.9);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#D2D966')
      .s()
      .p(
        'AmcGdQirirAAjyQAAjxCrirQCrirDxAAQDyAACrCrQCrCrAADxQAADyirCrQirCrjyAAQjxAAirirg',
      );
    this.shape_1.setTransform(0.0371, -81.0129, 0.9, 0.9);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#F2F2F2')
      .s()
      .p(
        'AkQKGQh+g2hhhhQjNjNAAkiQAAiNA3iDQA1h+BhhgQBhhhB+g2QCDg3CNAAQEiAADODOQDNDMAAEiQAAEijNDNQjODOkiAAQiNAAiDg3g',
      );
    this.shape_2.setTransform(0.025, 84.75);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .lf(['#FFFFFF', '#F2F2F2'], [0, 1], 0, -27.6, 0, 29.6)
      .s()
      .p(
        'AkYKZQiBg3hkhkQhkhkg3iBQg4iGAAiTQAAiSA4iGQA3iBBkhkQBkhkCBg3QCGg4CSAAQCTAACGA4QCBA3BkBkQBkBkA3CBQA4CGAACSQAACTg4CGQg3CBhkBkQhkBkiBA3QiGA4iTAAQiSAAiGg4g',
      );
    this.shape_3.setTransform(0.025, -81.675);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#F2F2F2').s().p('AirK4IAA1vIFXAAIAAVvg');
    this.shape_4.setTransform(0.025, 36.05);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.OperationAndValue,
    new cjs.Rectangle(-81.8, -153.8, 163.1, 351.8),
    null,
  );

  (lib.numberBarRight = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // picture
    this.s9 = new lib.b9();
    this.s9.name = 's9';
    this.s9.setTransform(124, 123.95, 1, 1, 0, 0, 0, 34, 34);

    this.s8 = new lib.b8();
    this.s8.name = 's8';
    this.s8.setTransform(20, 89.95);

    this.s7 = new lib.b7();
    this.s7.name = 's7';
    this.s7.setTransform(-19, 123.95, 1, 1, 0, 0, 0, 34, 34);

    this.s6 = new lib.b6();
    this.s6.name = 's6';
    this.s6.setTransform(124, 55.95, 1, 1, 0, 0, 0, 34, 34);

    this.s5 = new lib.b5();
    this.s5.name = 's5';
    this.s5.setTransform(20, 21.95);

    this.s4 = new lib.b4();
    this.s4.name = 's4';
    this.s4.setTransform(-19, 55.95, 1, 1, 0, 0, 0, 34, 34);

    this.s3 = new lib.b3();
    this.s3.name = 's3';
    this.s3.setTransform(121, -16.45, 1, 1, 0, 0, 0, 31, 31);

    this.s2 = new lib.b2();
    this.s2.name = 's2';
    this.s2.setTransform(51, -16.45, 1, 1, 0, 0, 0, 31, 31);

    this.s1 = new lib.b1();
    this.s1.name = 's1';
    this.s1.setTransform(-77.5, -69.95, 1, 1, 0, 0, 0, -24.5, -22.5);

    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AiMF9QhKilgGi0IAAhHQAIjRBljBQBJiLBchXICnCoQhhBgg2B+Qg3CDAACOQAACPA3CCQA2B+BhBhIioCnQh7h7hGifg',
      );
    this.shape.setTransform(-104.3858, 58.2841, 0.892, 0.892, 0, 0, 180);

    this.sel = new lib.numberButton();
    this.sel.name = 'sel';
    this.sel.setTransform(-22.7, 32.3, 0.5946, 0.5945, 0, 0, 0, 26.5, 14.4);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f().s('#D2D966').ss(12.3, 1, 1).p('AhHAAICPAA');
    this.shape_1.setTransform(-79.225, 54.75);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.s1 },
            { t: this.s2 },
            { t: this.s3 },
            { t: this.s4 },
            { t: this.s5 },
            { t: this.s6 },
            { t: this.s7 },
            { t: this.s8 },
            { t: this.s9 },
          ],
        })
        .to(
          { state: [{ t: this.shape_1 }, { t: this.sel }, { t: this.shape }] },
          1,
        )
        .wait(1),
    );

    // frame
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_2.setTransform(53.0003, 55.0003, 1.9565, 1.9565);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AwFwFMAgLAAAMAAAAgLMggLAAAg');
    this.shape_3.setTransform(53.975, 54.975);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f('#D2D966').s().p('AwFQGMAAAggLMAgLAAAMAAAAgLg');
    this.shape_4.setTransform(53.975, 54.975);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_4 },
            { t: this.shape_3 },
            {
              t: this.shape_2,
              p: { scaleX: 1.9565, scaleY: 1.9565, x: 53.0003, y: 55.0003 },
            },
          ],
        })
        .to(
          {
            state: [
              {
                t: this.shape_2,
                p: { scaleX: 1.1634, scaleY: 1.1632, x: -5.7559, y: 56.1345 },
              },
            ],
          },
          1,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-124.1, -57.5, 289.6, 225);

  (lib.numberBarAlt2 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // picture
    this.s9 = new lib.b18();
    this.s9.name = 's9';
    this.s9.setTransform(124.3, 123.95, 1, 1, 0, 0, 0, 34, 34);

    this.s8 = new lib.b17();
    this.s8.name = 's8';
    this.s8.setTransform(19.7, 89.95);

    this.s7 = new lib.b16();
    this.s7.name = 's7';
    this.s7.setTransform(-18.7, 123.95, 1, 1, 0, 0, 0, 34, 34);

    this.s6 = new lib.b15();
    this.s6.name = 's6';
    this.s6.setTransform(90.3, 21.65);

    this.s5 = new lib.b14();
    this.s5.name = 's5';
    this.s5.setTransform(53.7, 55.65, 1, 1, 0, 0, 0, 34, 34);

    this.s4 = new lib.b13();
    this.s4.name = 's4';
    this.s4.setTransform(-52.7, 21.65);

    this.s3 = new lib.b12();
    this.s3.name = 's3';
    this.s3.setTransform(90.3, -47.45);

    this.s2 = new lib.b11();
    this.s2.name = 's2';
    this.s2.setTransform(50.7, -16.45, 1, 1, 0, 0, 0, 31, 31);

    this.s1 = new lib.b10();
    this.s1.name = 's1';
    this.s1.setTransform(-77.2, -69.95, 1, 1, 0, 0, 0, -24.5, -22.5);

    this.sel = new lib.numberButton();
    this.sel.name = 'sel';
    this.sel.setTransform(-22.7, 32.3, 0.5946, 0.5945, 0, 0, 0, 26.5, 14.4);

    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#D2D966').ss(12.3, 1, 1).p('AhHAAICPAA');
    this.shape.setTransform(-79.225, 54.75);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.s1 },
            { t: this.s2 },
            { t: this.s3 },
            { t: this.s4 },
            { t: this.s5 },
            { t: this.s6 },
            { t: this.s7 },
            { t: this.s8 },
            { t: this.s9 },
          ],
        })
        .to({ state: [{ t: this.shape }, { t: this.sel }] }, 1)
        .wait(1),
    );

    // frame
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape_1.setTransform(53.0003, 55.0003, 1.9565, 1.9565);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AwFwFMAgLAAAMAAAAgLMggLAAAg');
    this.shape_2.setTransform(53.975, 54.975);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#D2D966').s().p('AwFQGMAAAggLMAgLAAAMAAAAgLg');
    this.shape_3.setTransform(53.975, 54.975);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#D2D966')
      .s()
      .p(
        'AiMF9QhKilgGi0IAAhHQAIjRBljBQBJiLBchXICnCoQhhBgg2B+Qg3CDAACOQAACPA3CCQA2B+BhBhIioCnQh7h7hGifg',
      );
    this.shape_4.setTransform(-104.3858, 58.2841, 0.892, 0.892, 0, 0, 180);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_3 },
            { t: this.shape_2 },
            {
              t: this.shape_1,
              p: { scaleX: 1.9565, scaleY: 1.9565, x: 53.0003, y: 55.0003 },
            },
          ],
        })
        .to(
          {
            state: [
              {
                t: this.shape_1,
                p: { scaleX: 1.1634, scaleY: 1.1632, x: -5.7559, y: 56.1345 },
              },
              { t: this.shape_4 },
            ],
          },
          1,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-124.1, -57.5, 289.6, 225);

  (lib.numberBarAlt = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // picture
    this.s9 = new lib.b90();
    this.s9.name = 's9';
    this.s9.setTransform(124, 123.95, 1, 1, 0, 0, 0, 34, 34);

    this.s8 = new lib.b80();
    this.s8.name = 's8';
    this.s8.setTransform(54, 123.95, 1, 1, 0, 0, 0, 34, 34);

    this.s7 = new lib.b70();
    this.s7.name = 's7';
    this.s7.setTransform(-53, 89.95);

    this.s6 = new lib.b60();
    this.s6.name = 's6';
    this.s6.setTransform(124, 55.95, 1, 1, 0, 0, 0, 34, 34);

    this.s5 = new lib.b50();
    this.s5.name = 's5';
    this.s5.setTransform(54, 55.95, 1, 1, 0, 0, 0, 34, 34);

    this.s4 = new lib.b40();
    this.s4.name = 's4';
    this.s4.setTransform(-53, 21.95);

    this.s3 = new lib.b30();
    this.s3.name = 's3';
    this.s3.setTransform(121, -16.45, 1, 1, 0, 0, 0, 31, 31);

    this.s2 = new lib.b20();
    this.s2.name = 's2';
    this.s2.setTransform(51, -16.45, 1, 1, 0, 0, 0, 31, 31);

    this.s1 = new lib.b10();
    this.s1.name = 's1';
    this.s1.setTransform(-77.5, -69.95, 1, 1, 0, 0, 0, -24.5, -22.5);

    this.sel = new lib.numberButton();
    this.sel.name = 'sel';
    this.sel.setTransform(100.3, 32.3, 0.5946, 0.5945, 0, 0, 0, 26.5, 14.4);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.s1 },
            { t: this.s2 },
            { t: this.s3 },
            { t: this.s4 },
            { t: this.s5 },
            { t: this.s6 },
            { t: this.s7 },
            { t: this.s8 },
            { t: this.s9 },
          ],
        })
        .to({ state: [{ t: this.sel }] }, 1)
        .wait(1),
    );

    // frame
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(53.0003, 55.0003, 1.9565, 1.9565);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AwFwFMAgLAAAMAAAAgLMggLAAAg');
    this.shape_1.setTransform(53.975, 54.975);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics.f('#D2D966').s().p('AwFQGMAAAggLMAgLAAAMAAAAgLg');
    this.shape_2.setTransform(53.975, 54.975);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#D2D966')
      .s()
      .p(
        'AiMF9QhKilgGi0IAAhHQAIjRBljBQBJiLBchXICnCoQhhBgg2B+Qg3CDAACOQAACPA3CCQA2B+BhBhIioCnQh7h7hGifg',
      );
    this.shape_3.setTransform(211.8858, 58.2341, 0.892, 0.892);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f()
      .s('#D2D966')
      .ss(12.3, 1, 1)
      .p('AAxAAIhEAAABkAAIgFAAAg7AAIgoAA');
    this.shape_4.setTransform(190, 56.7);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_2 },
            { t: this.shape_1 },
            {
              t: this.shape,
              p: { scaleX: 1.9565, scaleY: 1.9565, x: 53.0003, y: 55.0003 },
            },
          ],
        })
        .to(
          {
            state: [
              { t: this.shape_4 },
              {
                t: this.shape,
                p: { scaleX: 1.1634, scaleY: 1.1632, x: 117.2441, y: 56.1345 },
              },
              { t: this.shape_3 },
            ],
          },
          1,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-59.5, -57.5, 291.1, 225);

  (lib.numberBar = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // picture
    this.s9 = new lib.b9();
    this.s9.name = 's9';
    this.s9.setTransform(124, 123.95, 1, 1, 0, 0, 0, 34, 34);

    this.s8 = new lib.b8();
    this.s8.name = 's8';
    this.s8.setTransform(54, 123.95, 1, 1, 0, 0, 0, 34, 34);

    this.s7 = new lib.b7();
    this.s7.name = 's7';
    this.s7.setTransform(-19, 123.95, 1, 1, 0, 0, 0, 34, 34);

    this.s6 = new lib.b6();
    this.s6.name = 's6';
    this.s6.setTransform(124, 55.95, 1, 1, 0, 0, 0, 34, 34);

    this.s5 = new lib.b5();
    this.s5.name = 's5';
    this.s5.setTransform(54, 55.95, 1, 1, 0, 0, 0, 34, 34);

    this.s4 = new lib.b4();
    this.s4.name = 's4';
    this.s4.setTransform(-19, 55.95, 1, 1, 0, 0, 0, 34, 34);

    this.s3 = new lib.b3();
    this.s3.name = 's3';
    this.s3.setTransform(121, -16.45, 1, 1, 0, 0, 0, 31, 31);

    this.s2 = new lib.b2();
    this.s2.name = 's2';
    this.s2.setTransform(51, -16.45, 1, 1, 0, 0, 0, 31, 31);

    this.s1 = new lib.b1();
    this.s1.name = 's1';
    this.s1.setTransform(-77.5, -69.95, 1, 1, 0, 0, 0, -24.5, -22.5);

    this.sel = new lib.numberButton();
    this.sel.name = 'sel';
    this.sel.setTransform(100.3, 32.3, 0.5946, 0.5945, 0, 0, 0, 26.5, 14.4);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.s1 },
            { t: this.s2 },
            { t: this.s3 },
            { t: this.s4 },
            { t: this.s5 },
            { t: this.s6 },
            { t: this.s7 },
            { t: this.s8 },
            { t: this.s9 },
          ],
        })
        .to({ state: [{ t: this.sel }] }, 1)
        .wait(1),
    );

    // frame
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D2D966')
      .s()
      .p(
        'AnzI/QhLAAAAhLIAAvnQAAhLBLAAIPnAAQBLAAAABLIAAPnQAABLhLAAgAnuHuIPcAAIAAvcIvcAAg',
      );
    this.shape.setTransform(53.0003, 55.0003, 1.9565, 1.9565);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f()
      .s('#D2D966')
      .ss(0.1, 1, 1)
      .p('AwFwFMAgLAAAMAAAAgLMggLAAAg');
    this.shape_1.setTransform(53.975, 54.975);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics.f('#D2D966').s().p('AwFQGMAAAggLMAgLAAAMAAAAgLg');
    this.shape_2.setTransform(53.975, 54.975);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#D2D966')
      .s()
      .p(
        'AiMF9QhKilgGi0IAAhHQAIjRBljBQBJiLBchXICnCoQhhBgg2B+Qg3CDAACOQAACPA3CCQA2B+BhBhIioCnQh7h7hGifg',
      );
    this.shape_3.setTransform(211.8858, 58.2341, 0.892, 0.892);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f()
      .s('#D2D966')
      .ss(12.3, 1, 1)
      .p('Ag7AAIgoAAABkAAIgFAAAAxAAIhEAA');
    this.shape_4.setTransform(190, 56.7);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_2 },
            { t: this.shape_1 },
            {
              t: this.shape,
              p: { scaleX: 1.9565, scaleY: 1.9565, x: 53.0003, y: 55.0003 },
            },
          ],
        })
        .to(
          {
            state: [
              { t: this.shape_4 },
              {
                t: this.shape,
                p: { scaleX: 1.1634, scaleY: 1.1632, x: 117.2441, y: 56.1345 },
              },
              { t: this.shape_3 },
            ],
          },
          1,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-59.5, -57.5, 291.1, 225);

  (lib.ProgressMeterCapsule = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1),
    );

    // text
    this.txtExpression = new lib.comsuntexsymbolsValueTextBlack();
    this.txtExpression.name = 'txtExpression';
    this.txtExpression.setTransform(6, 12.5, 0.5184, 0.5183, 0, 0, 0, 12.6, 24);

    this.timeline.addTween(cjs.Tween.get(this.txtExpression).wait(5));

    // capsules
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('AhwBLQg+AAAAgwIAAg1QAAgwA+AAIDhAAQA+AAAAAwIAAA1QAAAwg+AAg');

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#CCFF66')
      .s()
      .p('AhwBLQg+AAAAgwIAAg1QAAgwA+AAIDhAAQA+AAAAAwIAAA1QAAAwg+AAg');

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#990033')
      .s()
      .p('AhwBLQg+AAAAgwIAAg1QAAgwA+AAIDhAAQA+AAAAAwIAAA1QAAAwg+AAg');

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#3399FF')
      .s()
      .p('AhwBLQg+AAAAgwIAAg1QAAgwA+AAIDhAAQA+AAAAAwIAAA1QAAAwg+AAg');

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.5, -15.5, 48.2, 57.5);

  (lib.comsuntexsymbolsScoreboard = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // text
    this.progressPanel = new lib.ProgressPanel();
    this.progressPanel.name = 'progressPanel';
    this.progressPanel.setTransform(283.95, 20.7, 1, 1, 0, 0, 0, 274.1, 0);

    this.timeline.addTween(cjs.Tween.get(this.progressPanel).wait(1));

    // buttons
    this.muteBtn = new lib.Scoreboard_muteBtn();
    this.muteBtn.name = 'muteBtn';
    this.muteBtn.setTransform(778.45, 20);

    this.musicBtn = new lib.Scoreboard_musicBtn();
    this.musicBtn.name = 'musicBtn';
    this.musicBtn.setTransform(738.45, 20);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.musicBtn }, { t: this.muteBtn }] })
        .wait(1),
    );

    // bg
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#000000').s().p('Eg+zADSIAAmjMB9nAAAIAAGjg');
    this.shape.setTransform(400, 21);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsScoreboard,
    new cjs.Rectangle(-2, 0, 804, 42),
    null,
  );

  (lib.PracticeMenu = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 2
    this.text = new cjs.Text(
      'Select a practice round:',
      "bold 24px 'Roboto'",
      '#003399',
    );
    this.text.textAlign = 'center';
    this.text.lineHeight = 35;
    this.text.parent = this;
    this.text.setTransform(398.05, 244.75);

    this.round4Btn = new lib.roundBtn4();
    this.round4Btn.name = 'round4Btn';
    this.round4Btn.setTransform(550, 330.6, 1.1111, 1.1106);

    this.round3Btn = new lib.roundBtn3();
    this.round3Btn.name = 'round3Btn';
    this.round3Btn.setTransform(450, 330.6, 1.1111, 1.1106);

    this.round2Btn = new lib.roundBtn2();
    this.round2Btn.name = 'round2Btn';
    this.round2Btn.setTransform(350, 330.6, 1.1111, 1.1106);

    this.round1Btn = new lib.roundBtn1();
    this.round1Btn.name = 'round1Btn';
    this.round1Btn.setTransform(250, 330.6, 1.1111, 1.1106);

    this.text_1 = new cjs.Text(
      "You've finished earning stickers,\nbut you can still practice!",
      "bold 26px 'Roboto'",
      '#003399',
    );
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 37;
    this.text_1.parent = this;
    this.text_1.setTransform(399.05, 135.9);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.text_1 },
            { t: this.round1Btn },
            { t: this.round2Btn },
            { t: this.round3Btn },
            { t: this.round4Btn },
            { t: this.text },
          ],
        })
        .wait(1),
    );

    // Layer 4
    this.moreBtn = new lib.moreBtn();
    this.moreBtn.name = 'moreBtn';
    this.moreBtn.setTransform(398.05, 425.4);

    this.timeline.addTween(cjs.Tween.get(this.moreBtn).wait(1));

    // bg
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'EgiXAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBEvAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape.setTransform(400, 280);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // shadow
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.098)')
      .s()
      .p(
        'EgiXAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBEvAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_1.setTransform(405, 285);

    this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

    // veil
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(255,255,255,0.498)')
      .s()
      .p('Eg+fAu4MAAAhdvMB8/AAAMAAABdvg');
    this.shape_2.setTransform(400, 300);

    this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.PracticeMenu,
    new cjs.Rectangle(0, 0, 800, 600),
    null,
  );

  (lib.comsuntexsymbolsGameFrame = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // veil
    this.veil = new lib.GameFrame_veil();
    this.veil.name = 'veil';
    this.veil.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.veil).wait(1));

    // changeRoundBtn
    this.changeRoundBtn = new lib.Scoreboard_changeRoundBtn();
    this.changeRoundBtn.name = 'changeRoundBtn';
    this.changeRoundBtn.setTransform(672.3, 578.8);

    this.timeline.addTween(cjs.Tween.get(this.changeRoundBtn).wait(1));

    // scoreboard
    this.scoreboard = new lib.comsuntexsymbolsScoreboard();
    this.scoreboard.name = 'scoreboard';
    this.scoreboard.setTransform(355.1, 573, 1, 1, 0, 0, 0, 355.1, 13);

    this.timeline.addTween(cjs.Tween.get(this.scoreboard).wait(1));

    // practiceMenu
    this.practiceMenu = new lib.PracticeMenu();
    this.practiceMenu.name = 'practiceMenu';
    this.practiceMenu.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.practiceMenu).wait(1));

    // endScreen
    this.endScreen = new lib.EndScreen();
    this.endScreen.name = 'endScreen';
    this.endScreen.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.endScreen).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsGameFrame,
    new cjs.Rectangle(-5, -5, 810, 610),
    null,
  );

  (lib.panel = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };
    this.frame_5 = function () {
      this.stop();
    };
    this.frame_6 = function () {
      this.stop();
    };
    this.frame_7 = function () {
      this.stop();
    };
    this.frame_8 = function () {
      this.stop();
    };
    this.frame_9 = function () {
      this.stop();
    };
    this.frame_10 = function () {
      this.stop();
    };
    this.frame_11 = function () {
      this.stop();
    };
    this.frame_12 = function () {
      this.stop();
    };
    this.frame_13 = function () {
      this.stop();
    };
    this.frame_14 = function () {
      this.stop();
    };
    this.frame_15 = function () {
      this.stop();
    };
    this.frame_16 = function () {
      this.stop();
    };
    this.frame_17 = function () {
      this.stop();
    };
    this.frame_18 = function () {
      this.stop();
    };
    this.frame_19 = function () {
      this.stop();
    };
    this.frame_20 = function () {
      this.stop();
    };
    this.frame_21 = function () {
      this.stop();
    };
    this.frame_22 = function () {
      this.stop();
    };
    this.frame_23 = function () {
      this.stop();
    };
    this.frame_24 = function () {
      this.stop();
    };
    this.frame_25 = function () {
      this.stop();
    };
    this.frame_26 = function () {
      this.stop();
    };
    this.frame_27 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1)
        .call(this.frame_5)
        .wait(1)
        .call(this.frame_6)
        .wait(1)
        .call(this.frame_7)
        .wait(1)
        .call(this.frame_8)
        .wait(1)
        .call(this.frame_9)
        .wait(1)
        .call(this.frame_10)
        .wait(1)
        .call(this.frame_11)
        .wait(1)
        .call(this.frame_12)
        .wait(1)
        .call(this.frame_13)
        .wait(1)
        .call(this.frame_14)
        .wait(1)
        .call(this.frame_15)
        .wait(1)
        .call(this.frame_16)
        .wait(1)
        .call(this.frame_17)
        .wait(1)
        .call(this.frame_18)
        .wait(1)
        .call(this.frame_19)
        .wait(1)
        .call(this.frame_20)
        .wait(1)
        .call(this.frame_21)
        .wait(1)
        .call(this.frame_22)
        .wait(1)
        .call(this.frame_23)
        .wait(1)
        .call(this.frame_24)
        .wait(1)
        .call(this.frame_25)
        .wait(1)
        .call(this.frame_26)
        .wait(1)
        .call(this.frame_27)
        .wait(1),
    );

    // Layer 1
    this.b2 = new lib.m2();
    this.b2.name = 'b2';
    this.b2.setTransform(-299.5, -66, 1, 1, 0, 0, 0, 27.5, 26.5);

    this.nAe = new lib.ProgressMeterCapsule();
    this.nAe.name = 'nAe';
    this.nAe.setTransform(299.5, 58.05);

    this.nAd = new lib.ProgressMeterCapsule();
    this.nAd.name = 'nAd';
    this.nAd.setTransform(299.5, 36.05);

    this.n9d = new lib.ProgressMeterCapsule();
    this.n9d.name = 'n9d';
    this.n9d.setTransform(224, 36.05);

    this.n8d = new lib.ProgressMeterCapsule();
    this.n8d.name = 'n8d';
    this.n8d.setTransform(149.25, 36.05);

    this.nAc = new lib.ProgressMeterCapsule();
    this.nAc.name = 'nAc';
    this.nAc.setTransform(299.5, 14.05);

    this.n9c = new lib.ProgressMeterCapsule();
    this.n9c.name = 'n9c';
    this.n9c.setTransform(224, 14.05);

    this.n8c = new lib.ProgressMeterCapsule();
    this.n8c.name = 'n8c';
    this.n8c.setTransform(149.25, 14.05);

    this.n7c = new lib.ProgressMeterCapsule();
    this.n7c.name = 'n7c';
    this.n7c.setTransform(74.75, 14.05);

    this.n6c = new lib.ProgressMeterCapsule();
    this.n6c.name = 'n6c';
    this.n6c.setTransform(0, 14.05);

    this.nAb = new lib.ProgressMeterCapsule();
    this.nAb.name = 'nAb';
    this.nAb.setTransform(299.5, -8.95);

    this.n9b = new lib.ProgressMeterCapsule();
    this.n9b.name = 'n9b';
    this.n9b.setTransform(224, -8.95);

    this.n8b = new lib.ProgressMeterCapsule();
    this.n8b.name = 'n8b';
    this.n8b.setTransform(149.25, -8.95);

    this.n7b = new lib.ProgressMeterCapsule();
    this.n7b.name = 'n7b';
    this.n7b.setTransform(74.75, -8.95);

    this.n6b = new lib.ProgressMeterCapsule();
    this.n6b.name = 'n6b';
    this.n6b.setTransform(0, -8.95);

    this.n5b = new lib.ProgressMeterCapsule();
    this.n5b.name = 'n5b';
    this.n5b.setTransform(-75, -8.95);

    this.n4b = new lib.ProgressMeterCapsule();
    this.n4b.name = 'n4b';
    this.n4b.setTransform(-150, -8.95);

    this.nAa = new lib.ProgressMeterCapsule();
    this.nAa.name = 'nAa';
    this.nAa.setTransform(299.5, -31.95);

    this.n9a = new lib.ProgressMeterCapsule();
    this.n9a.name = 'n9a';
    this.n9a.setTransform(224, -31.95);

    this.n8a = new lib.ProgressMeterCapsule();
    this.n8a.name = 'n8a';
    this.n8a.setTransform(149.25, -31.95);

    this.n7a = new lib.ProgressMeterCapsule();
    this.n7a.name = 'n7a';
    this.n7a.setTransform(74.75, -31.95);

    this.n6a = new lib.ProgressMeterCapsule();
    this.n6a.name = 'n6a';
    this.n6a.setTransform(0, -31.95);

    this.n5a = new lib.ProgressMeterCapsule();
    this.n5a.name = 'n5a';
    this.n5a.setTransform(-75, -31.95);

    this.n4a = new lib.ProgressMeterCapsule();
    this.n4a.name = 'n4a';
    this.n4a.setTransform(-150, -31.95);

    this.n3a = new lib.ProgressMeterCapsule();
    this.n3a.name = 'n3a';
    this.n3a.setTransform(-224.75, -31.95);

    this.n2a = new lib.ProgressMeterCapsule();
    this.n2a.name = 'n2a';
    this.n2a.setTransform(-299.25, -31.95);

    this.b6 = new lib.m6();
    this.b6.name = 'b6';
    this.b6.setTransform(-0.25, -66, 1, 1, 0, 0, 0, 27.5, 26.5);

    this.b7 = new lib.m7();
    this.b7.name = 'b7';
    this.b7.setTransform(74.55, -66, 1, 1, 0, 0, 0, 27.5, 26.5);

    this.bA = new lib.mA();
    this.bA.name = 'bA';
    this.bA.setTransform(299, -66, 1, 1, 0, 0, 0, 27.5, 26.5);

    this.b9 = new lib.m9();
    this.b9.name = 'b9';
    this.b9.setTransform(224.15, -66, 1, 1, 0, 0, 0, 27.5, 26.5);

    this.b8 = new lib.m8();
    this.b8.name = 'b8';
    this.b8.setTransform(149.35, -66, 1, 1, 0, 0, 0, 27.5, 26.5);

    this.b5 = new lib.m5();
    this.b5.name = 'b5';
    this.b5.setTransform(-75.05, -66, 1, 1, 0, 0, 0, 27.5, 26.5);

    this.b4 = new lib.m4();
    this.b4.name = 'b4';
    this.b4.setTransform(-149.85, -66, 1, 1, 0, 0, 0, 27.5, 26.5);

    this.b3 = new lib.m3();
    this.b3.name = 'b3';
    this.b3.setTransform(-224.65, -66, 1, 1, 0, 0, 0, 27.5, 26.5);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.b3 },
            { t: this.b4 },
            { t: this.b5 },
            { t: this.b8 },
            { t: this.b9 },
            { t: this.bA },
            { t: this.b7 },
            { t: this.b6 },
            { t: this.n2a },
            { t: this.n3a },
            { t: this.n4a },
            { t: this.n5a },
            { t: this.n6a },
            { t: this.n7a },
            { t: this.n8a },
            { t: this.n9a },
            { t: this.nAa },
            { t: this.n4b },
            { t: this.n5b },
            { t: this.n6b },
            { t: this.n7b },
            { t: this.n8b },
            { t: this.n9b },
            { t: this.nAb },
            { t: this.n6c },
            { t: this.n7c },
            { t: this.n8c },
            { t: this.n9c },
            { t: this.nAc },
            { t: this.n8d },
            { t: this.n9d },
            { t: this.nAd },
            { t: this.nAe },
            { t: this.b2 },
          ],
        })
        .wait(28),
    );

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EF8346')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape.setTransform(-75.25, -0.4);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EF8346')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_1.setTransform(-150.25, -0.4);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EF8346')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_2.setTransform(74.5, -0.4);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#EF8346')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_3.setTransform(149, -0.4);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#EF8346')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_4.setTransform(223.75, -0.4);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#EF8346')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_5.setTransform(299.25, -0.4);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#EF8346')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_6.setTransform(-225, -0.4);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#EF8346')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_7.setTransform(0, -0.4);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#EF8346')
      .s()
      .p('AjSOdQhAAAAAhAIAA64QAAhBBAAAIGlAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_8.setTransform(-299.5, -0.4);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#33CC66')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_9.setTransform(-299.5, -0.4);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#FF0066')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_10.setTransform(-299.5, -0.4);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#FF0099')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_11.setTransform(-225, -0.4);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#33CC66')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_12.setTransform(-225, -0.4);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#33CC66')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_13.setTransform(-150.25, -0.4);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#33CC66')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_14.setTransform(-299.5, -0.4);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#33CC66')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_15.setTransform(-75.25, -0.4);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#33CC66')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_16.setTransform(74.5, -0.4);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#33CC66')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_17.setTransform(149, -0.4);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#33CC66')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_18.setTransform(223.75, -0.4);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#33CC66')
      .s()
      .p('AjROdQhBAAAAhAIAA64QAAhBBBAAIGkAAQBAAAAABBIAAa4QAABAhAAAg');
    this.shape_19.setTransform(299.25, -0.4);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_8 },
            { t: this.shape_7, p: { x: 0 } },
            { t: this.shape_6, p: { x: -225 } },
            { t: this.shape_5, p: { x: 299.25 } },
            { t: this.shape_4, p: { x: 223.75 } },
            { t: this.shape_3, p: { x: 149 } },
            { t: this.shape_2, p: { x: 74.5 } },
            { t: this.shape_1, p: { x: -150.25 } },
            { t: this.shape, p: { x: -75.25 } },
          ],
        })
        .to(
          {
            state: [
              { t: this.shape_9, p: { x: -299.5 } },
              { t: this.shape_7, p: { x: 0 } },
              { t: this.shape_6, p: { x: -225 } },
              { t: this.shape_5, p: { x: 299.25 } },
              { t: this.shape_4, p: { x: 223.75 } },
              { t: this.shape_3, p: { x: 149 } },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_9, p: { x: -225 } },
              { t: this.shape_5, p: { x: 299.25 } },
              { t: this.shape_4, p: { x: 223.75 } },
              { t: this.shape_3, p: { x: 149 } },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_4, p: { x: 299.25 } },
              { t: this.shape_3, p: { x: 223.75 } },
              { t: this.shape_2, p: { x: 149 } },
              { t: this.shape_1, p: { x: 74.5 } },
              { t: this.shape_9, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_4, p: { x: 299.25 } },
              { t: this.shape_3, p: { x: 223.75 } },
              { t: this.shape_2, p: { x: 149 } },
              { t: this.shape_1, p: { x: 74.5 } },
              { t: this.shape, p: { x: -150.25 } },
              { t: this.shape_9, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_9, p: { x: 0 } },
              { t: this.shape_6, p: { x: -225 } },
              { t: this.shape_5, p: { x: 299.25 } },
              { t: this.shape_4, p: { x: 223.75 } },
              { t: this.shape_3, p: { x: 149 } },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_4, p: { x: 299.25 } },
              { t: this.shape_3, p: { x: 223.75 } },
              { t: this.shape_2, p: { x: 149 } },
              { t: this.shape_9, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_4, p: { x: 299.25 } },
              { t: this.shape_3, p: { x: 223.75 } },
              { t: this.shape_9, p: { x: 149 } },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_4, p: { x: 299.25 } },
              { t: this.shape_9, p: { x: 223.75 } },
              { t: this.shape_3, p: { x: 149 } },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_9, p: { x: 299.25 } },
              { t: this.shape_4, p: { x: 223.75 } },
              { t: this.shape_3, p: { x: 149 } },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_10 },
              { t: this.shape_7, p: { x: 0 } },
              { t: this.shape_6, p: { x: -225 } },
              { t: this.shape_5, p: { x: 299.25 } },
              { t: this.shape_4, p: { x: 223.75 } },
              { t: this.shape_3, p: { x: 149 } },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_11, p: { x: -225 } },
              { t: this.shape_5, p: { x: 299.25 } },
              { t: this.shape_4, p: { x: 223.75 } },
              { t: this.shape_3, p: { x: 149 } },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_4, p: { x: 299.25 } },
              { t: this.shape_3, p: { x: 223.75 } },
              { t: this.shape_2, p: { x: 149 } },
              { t: this.shape_1, p: { x: 74.5 } },
              { t: this.shape_11, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_4, p: { x: 299.25 } },
              { t: this.shape_3, p: { x: 223.75 } },
              { t: this.shape_2, p: { x: 149 } },
              { t: this.shape_1, p: { x: 74.5 } },
              { t: this.shape, p: { x: -150.25 } },
              { t: this.shape_11, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_11, p: { x: 0 } },
              { t: this.shape_6, p: { x: -225 } },
              { t: this.shape_5, p: { x: 299.25 } },
              { t: this.shape_4, p: { x: 223.75 } },
              { t: this.shape_3, p: { x: 149 } },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_4, p: { x: 299.25 } },
              { t: this.shape_3, p: { x: 223.75 } },
              { t: this.shape_2, p: { x: 149 } },
              { t: this.shape_11, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_4, p: { x: 299.25 } },
              { t: this.shape_3, p: { x: 223.75 } },
              { t: this.shape_11, p: { x: 149 } },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_4, p: { x: 299.25 } },
              { t: this.shape_11, p: { x: 223.75 } },
              { t: this.shape_3, p: { x: 149 } },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_11, p: { x: 299.25 } },
              { t: this.shape_4, p: { x: 223.75 } },
              { t: this.shape_3, p: { x: 149 } },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_9, p: { x: -299.5 } },
              { t: this.shape_7, p: { x: 0 } },
              { t: this.shape_6, p: { x: -225 } },
              { t: this.shape_5, p: { x: 299.25 } },
              { t: this.shape_4, p: { x: 223.75 } },
              { t: this.shape_3, p: { x: 149 } },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_12 },
              { t: this.shape_5, p: { x: 299.25 } },
              { t: this.shape_4, p: { x: 223.75 } },
              { t: this.shape_3, p: { x: 149 } },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
              { t: this.shape_9, p: { x: -299.5 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_4, p: { x: 299.25 } },
              { t: this.shape_3, p: { x: 223.75 } },
              { t: this.shape_2, p: { x: 149 } },
              { t: this.shape_1, p: { x: 74.5 } },
              { t: this.shape_13 },
              { t: this.shape, p: { x: -75.25 } },
              { t: this.shape_12 },
              { t: this.shape_9, p: { x: -299.5 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_4, p: { x: 299.25 } },
              { t: this.shape_3, p: { x: 223.75 } },
              { t: this.shape_2, p: { x: 149 } },
              { t: this.shape_1, p: { x: 74.5 } },
              { t: this.shape, p: { x: -150.25 } },
              { t: this.shape_15, p: { x: -75.25 } },
              { t: this.shape_14, p: { x: -299.5 } },
              { t: this.shape_13 },
              { t: this.shape_12 },
              { t: this.shape_9, p: { x: -299.5 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_15, p: { x: 0 } },
              { t: this.shape_6, p: { x: -225 } },
              { t: this.shape_5, p: { x: 299.25 } },
              { t: this.shape_4, p: { x: 223.75 } },
              { t: this.shape_3, p: { x: 149 } },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
              { t: this.shape_14, p: { x: -75.25 } },
              { t: this.shape_13 },
              { t: this.shape_12 },
              { t: this.shape_9, p: { x: -299.5 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_4, p: { x: 299.25 } },
              { t: this.shape_3, p: { x: 223.75 } },
              { t: this.shape_2, p: { x: 149 } },
              { t: this.shape_16 },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
              { t: this.shape_15, p: { x: 0 } },
              { t: this.shape_14, p: { x: -75.25 } },
              { t: this.shape_13 },
              { t: this.shape_12 },
              { t: this.shape_9, p: { x: -299.5 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_4, p: { x: 299.25 } },
              { t: this.shape_3, p: { x: 223.75 } },
              { t: this.shape_17 },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
              { t: this.shape_16 },
              { t: this.shape_15, p: { x: 0 } },
              { t: this.shape_14, p: { x: -75.25 } },
              { t: this.shape_13 },
              { t: this.shape_12 },
              { t: this.shape_9, p: { x: -299.5 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_4, p: { x: 299.25 } },
              { t: this.shape_18 },
              { t: this.shape_3, p: { x: 149 } },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
              { t: this.shape_17 },
              { t: this.shape_16 },
              { t: this.shape_15, p: { x: 0 } },
              { t: this.shape_14, p: { x: -75.25 } },
              { t: this.shape_13 },
              { t: this.shape_12 },
              { t: this.shape_9, p: { x: -299.5 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7, p: { x: -299.5 } },
              { t: this.shape_6, p: { x: 0 } },
              { t: this.shape_5, p: { x: -225 } },
              { t: this.shape_19 },
              { t: this.shape_4, p: { x: 223.75 } },
              { t: this.shape_3, p: { x: 149 } },
              { t: this.shape_2, p: { x: 74.5 } },
              { t: this.shape_1, p: { x: -150.25 } },
              { t: this.shape, p: { x: -75.25 } },
              { t: this.shape_18 },
              { t: this.shape_17 },
              { t: this.shape_16 },
              { t: this.shape_15, p: { x: 0 } },
              { t: this.shape_14, p: { x: -75.25 } },
              { t: this.shape_13 },
              { t: this.shape_12 },
              { t: this.shape_9, p: { x: -299.5 } },
            ],
          },
          1,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-327, -92.9, 657.2, 192.9);

  (lib.GameStage = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // stuff...
    this.lSpinnerAlt = new lib.numberBarAlt();
    this.lSpinnerAlt.name = 'lSpinnerAlt';
    this.lSpinnerAlt.setTransform(
      141.05,
      375.15,
      1.1555,
      1.1555,
      0,
      0,
      0,
      44,
      48.7,
    );

    this.rSpinnerAlt = new lib.numberBarAlt2();
    this.rSpinnerAlt.name = 'rSpinnerAlt';
    this.rSpinnerAlt.setTransform(
      661.95,
      379,
      1.1555,
      1.1555,
      0,
      0,
      0,
      49.5,
      52.2,
    );

    this.rSpinner = new lib.numberBarRight();
    this.rSpinner.name = 'rSpinner';
    this.rSpinner.setTransform(603.5, 318.85, 1.1555, 1.1555);

    this.lSpinner = new lib.numberBar();
    this.lSpinner.name = 'lSpinner';
    this.lSpinner.setTransform(90.2, 318.85, 1.1555, 1.1555);

    this.stopLight = new lib.OperationAndValue();
    this.stopLight.name = 'stopLight';
    this.stopLight.setTransform(409, 301.95, 1, 1, 0, 0, 0, 0, 0.5);

    this.numberPnl = new lib.panel();
    this.numberPnl.name = 'numberPnl';
    this.numberPnl.setTransform(407, 102.5);

    this.startButton = new lib.start();
    this.startButton.name = 'startButton';
    this.startButton.setTransform(329.2, 651.45, 1, 1, 0, 0, 0, 39.2, 18.2);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.startButton },
            { t: this.numberPnl },
            { t: this.stopLight },
            { t: this.lSpinner },
            { t: this.rSpinner },
            { t: this.rSpinnerAlt },
            { t: this.lSpinnerAlt },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.GameStage,
    new cjs.Rectangle(21.5, 9.6, 774.5, 536.1999999999999),
    null,
  );

  // stage content:
  (lib.VIFRedoAddSub = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // gameFrame
    this.gameFrame = new lib.comsuntexsymbolsGameFrame();
    this.gameFrame.name = 'gameFrame';
    this.gameFrame.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.gameFrame).wait(1));

    // gameStage
    this.text = new cjs.Text('', "128px 'OpenSans-CondensedBold'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 185;
    this.text.parent = this;
    this.text.setTransform(-320.85, -182.8);

    this.gameStage = new lib.GameStage();
    this.gameStage.name = 'gameStage';
    this.gameStage.setTransform(387, 273.8, 1, 1, 0, 0, 0, 396, 273.8);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.gameStage }, { t: this.text }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new lib.AnMovieClip();
  p.nominalBounds = new cjs.Rectangle(74.1, 115.2, 730.9, 489.8);
  // library properties:
  lib.properties = {
    id: '35CF4A373E5DD84AADBA85687FE47CF4',
    width: 800,
    height: 600,
    fps: 24,
    color: '#FFFFFF',
    opacity: 1.0,
    manifest: [],
    preloads: [],
  };

  // bootstrap callback support:

  (lib.Stage = function (canvas) {
    createjs.Stage.call(this, canvas);
  }).prototype = p = new createjs.Stage();

  p.setAutoPlay = function (autoPlay) {
    this.tickEnabled = autoPlay;
  };
  p.play = function () {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
  };
  p.stop = function (ms) {
    if (ms) this.seek(ms);
    this.tickEnabled = false;
  };
  p.seek = function (ms) {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
  };
  p.getDuration = function () {
    return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
  };

  p.getTimelinePosition = function () {
    return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
  };

  an.bootcompsLoaded = an.bootcompsLoaded || [];
  if (!an.bootstrapListeners) {
    an.bootstrapListeners = [];
  }

  an.bootstrapCallback = function (fnCallback) {
    an.bootstrapListeners.push(fnCallback);
    if (an.bootcompsLoaded.length > 0) {
      for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
        fnCallback(an.bootcompsLoaded[i]);
      }
    }
  };

  an.compositions = an.compositions || {};
  an.compositions['35CF4A373E5DD84AADBA85687FE47CF4'] = {
    getStage: function () {
      return exportRoot.stage;
    },
    getLibrary: function () {
      return lib;
    },
    getSpriteSheet: function () {
      return ss;
    },
    getImages: function () {
      return img;
    },
  };

  an.compositionLoaded = function (id) {
    an.bootcompsLoaded.push(id);
    for (var j = 0; j < an.bootstrapListeners.length; j++) {
      an.bootstrapListeners[j](id);
    }
  };

  an.getComposition = function (id) {
    return an.compositions[id];
  };

  an.makeResponsive = function (
    isResp,
    respDim,
    isScale,
    scaleType,
    domContainers,
    stage,
  ) {
    var lastW,
      lastH,
      lastS = 1;
    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();
    function resizeCanvas() {
      var w = lib.properties.width,
        h = lib.properties.height;
      var iw = window.innerWidth,
        ih = window.innerHeight;
      var pRatio = window.devicePixelRatio || 1,
        xRatio = iw / w,
        yRatio = ih / h,
        sRatio = 1;
      if (isResp) {
        if (
          (respDim == 'width' && lastW == iw) ||
          (respDim == 'height' && lastH == ih)
        ) {
          sRatio = lastS;
        } else if (!isScale) {
          if (iw < w || ih < h) sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 1) {
          sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 2) {
          sRatio = Math.max(xRatio, yRatio);
        }
      }
      domContainers[0].width = w * pRatio * sRatio;
      domContainers[0].height = h * pRatio * sRatio;
      domContainers.forEach(function (container) {
        container.style.width = w * sRatio + 'px';
        container.style.height = h * sRatio + 'px';
      });
      stage.scaleX = pRatio * sRatio;
      stage.scaleY = pRatio * sRatio;
      lastW = iw;
      lastH = ih;
      lastS = sRatio;
      stage.tickOnUpdate = false;
      stage.update();
      stage.tickOnUpdate = true;
    }
  };
  an.handleSoundStreamOnTick = function (event) {
    if (!event.paused) {
      var stageChild = stage.getChildAt(0);
      if (!stageChild.paused || stageChild.ignorePause) {
        stageChild.syncStreamSounds();
      }
    }
  };
  an.handleFilterCache = function (event) {
    if (!event.paused) {
      var target = event.target;
      if (target) {
        if (target.filterCacheList) {
          for (var index = 0; index < target.filterCacheList.length; index++) {
            var cacheInst = target.filterCacheList[index];
            if (
              cacheInst.startFrame <= target.currentFrame &&
              target.currentFrame <= cacheInst.endFrame
            ) {
              cacheInst.instance.cache(
                cacheInst.x,
                cacheInst.y,
                cacheInst.w,
                cacheInst.h,
              );
            }
          }
        }
      }
    }
  };
}
